export interface Row {
  EprvId: number
  ChampionnatId: number
  ChampionnatLibelle: string
  EprvNom: string
  EprvLieu: string
  StructureNom: string
  EprvDateDebut: string
  EprvDateFin: string
  InfoSupVal: string | null
  Mandat: boolean
}

export interface Championnat {
  id: number
  name: string
}
// ChampionntId :
// 1 : Divers
// 2 : Jeunes
// 3 : Loisirs
// 4 : Para-tir à l'arc à 18m
// 5 : Rencontres Clubs Loisirs
// 6 : Tir 3D
// 7 : Tir à 18m
// 8 : Tir en Campagne
// 9 : Tir Nature
// 10 : Tournoi Poussin
// 11 : Para-tir à l'arc en extérieur
// 12 : Tir à l'Arc Extérieur
// 13 : Tir Beursault
// 14 : Run archery

// SELECT
//     `EprEpreuves`.`EprvId`,
//     `EprEpreuves`.`ChampionnatId`,
//     `ChampionnatLibelle`,
//     `EprvNom`,
//     `EprvLieu`,
//     `StructureNom`,
//     `EprvDateDebut`,
//     `EprvDateFin`,
//     `InfoSupVal`,
//     FALSE AS `Mandat`
// FROM
//     `ffta_exalto`.`EprEpreuves`
//     LEFT JOIN `EprChampionnats`
//       ON `EprChampionnats`.`ChampionnatId` = `EprEpreuves`.`ChampionnatId`
//     LEFT JOIN `ffta_exalto`.`Structures`
//       ON `ffta_exalto`.`EprEpreuves`.`StructureId` = `ffta_exalto`.`Structures`.`StructureId`
//     LEFT JOIN `EprInfosSup`
//       ON `EprInfosSup`.`EprvId` = `EprEpreuves`.`EprvId` AND `EprInfosSup`.`InfoSupKey` = 'OBSV'
// WHERE (`EprEpreuves`.`EprvDateDebut` >= '2022-01-01' AND `ChampionnatAffichage` = 'O')
// AND (`StructureCodeRegion` = 'CR06' OR (`StructureType` = 'FED' AND `EprvNom` = 'FITA HORIZON'))
// AND `EprvEtat` = 'A'
// ORDER BY
//     `EprvDateDebut`;

const data: Row[] = [
  {
    EprvId: 2025001,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2024-09-01",
    EprvDateFin: "2024-09-01",
    StructureNom: "VAGNEY",
    EprvNom: "TIR EN CAMPAGNE",
    EprvLieu: "VAGNEY",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025002,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2024-09-01",
    EprvDateFin: "2024-09-01",
    StructureNom: "CHAUMONT",
    EprvNom: "TIR EN CAMPAGNE",
    EprvLieu: "AGEVILLE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025003,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2024-09-07",
    EprvDateFin: "2024-09-08",
    StructureNom: "SARREGUEMINES",
    EprvNom: "CAMPAGNE DU MOULIN DES FAÏENCIERS ",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES Repiqueté",
    Mandat: true
  },
  {
    EprvId: 2025004,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2024-09-08",
    EprvDateFin: "2024-09-08",
    StructureNom: "GORZE",
    EprvNom: "NATURE GORZE - SEPT 2024 - 2 DEPARTS",
    EprvLieu: "GORZE",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025005,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2024-09-15",
    EprvDateFin: "2024-09-15",
    StructureNom: "SAINT DIZIER",
    EprvNom: "3D DE SAINT-DIZIER",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025006,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2024-09-29",
    EprvDateFin: "2024-09-29",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "CONCOURS 3D ",
    EprvLieu: "HAUCOURT MOULAINE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025007,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-05",
    EprvDateFin: "2024-10-06",
    StructureNom: "RETHEL",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "RETHEL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025008,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2024-10-06",
    EprvDateFin: "2024-10-06",
    StructureNom: "ILLKIRCH GRAFFENSTADEN",
    EprvNom: "CONCOURS TIR NATURE SELECTIF - OCTOBRE ROSE/ CHAMPIONNAT DEPARTEMENTAL 67",
    EprvLieu: "ILLKIRCH-GRAFFENSTADEN",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025009,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2024-10-12",
    EprvDateFin: "2024-10-12",
    StructureNom: "SAINT DIZIER",
    EprvNom: "RENCONTRE JEUNES & DEBUTANTS",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2025010,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-12",
    EprvDateFin: "2024-10-13",
    StructureNom: "SARREBOURG",
    EprvNom: "CONCOURS D'AUTOMNE - 3 DÉPARTS 18M",
    EprvLieu: "SARREBOURG",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025011,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-12",
    EprvDateFin: "2024-10-13",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CHALLENGE D'AUTOMNE",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025012,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-13",
    EprvDateFin: "2024-10-13",
    StructureNom: "SAINT DIZIER",
    EprvNom: "SAINT-DIZIER TIR À 18M",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025013,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2024-10-19",
    EprvDateFin: "2024-10-19",
    StructureNom: "SUIPPES",
    EprvNom: "PARTAGE TES FLECHES",
    EprvLieu: "SUIPPES",
    InfoSupVal: "Partage tes flèches",
    Mandat: false
  },
  {
    EprvId: 2025014,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2024-10-19",
    EprvDateFin: "2024-10-19",
    StructureNom: "MULHOUSE STA",
    EprvNom: "PARTAGE TES FLECHES",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Partage tes flèches",
    Mandat: false
  },
  {
    EprvId: 2025015,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-19",
    EprvDateFin: "2024-10-20",
    StructureNom: "CD MOSELLE",
    EprvNom: "CONCOURS SALLE CREUTZWALD",
    EprvLieu: "CREUTZWALD",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025016,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-19",
    EprvDateFin: "2024-10-20",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TIR SALLE",
    EprvLieu: "BRIENNE LE CHATEAU",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025017,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-19",
    EprvDateFin: "2024-10-20",
    StructureNom: "VERTUS",
    EprvNom: "CONCOURS EN SALLE",
    EprvLieu: "VERTUS",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025018,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-19",
    EprvDateFin: "2024-10-20",
    StructureNom: "CHAUMONT",
    EprvNom: "CHAMPINNAT DÉPARTEMENTAL CD 52 18M",
    EprvLieu: "CHAUMONT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025019,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-20",
    EprvDateFin: "2024-10-20",
    StructureNom: "WISSEMBOURG",
    EprvNom: "CHALLENGE AUTOMNE 2024",
    EprvLieu: "WISSEMBOURG",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025020,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-26",
    EprvDateFin: "2024-10-27",
    StructureNom: "BOULIGNY",
    EprvNom: "TIR A 18 M",
    EprvLieu: "BOULIGNY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025021,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-26",
    EprvDateFin: "2024-10-27",
    StructureNom: "FOLSCHVILLER",
    EprvNom: "CONCOURS SELECTIF INDIVIDUEL",
    EprvLieu: "FOLSCHVILLER",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025022,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-26",
    EprvDateFin: "2024-10-27",
    StructureNom: "ROMILLY SUR SEINE",
    EprvNom: "TIR EN SALLE ",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025023,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-26",
    EprvDateFin: "2024-10-27",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "CONCOURS SALLE CHÂLONS",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025024,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-10-27",
    EprvDateFin: "2024-10-27",
    StructureNom: "BRUNSTATT",
    EprvNom: "CONCOURS SELECTIF ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025025,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2024-10-27",
    EprvDateFin: "2024-10-27",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "TIR NATURE ",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025026,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-02",
    EprvDateFin: "2024-11-03",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE D'AUTOMNE 2024",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025027,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-02",
    EprvDateFin: "2024-11-03",
    StructureNom: "HETTANGE GRANDE",
    EprvNom: "CONCOURS SELECTIF VILLE HETTANGE GRANDE",
    EprvLieu: "HETTANGE GRANDE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025028,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-02",
    EprvDateFin: "2024-11-03",
    StructureNom: "VENDEUVRE SUR BARSE",
    EprvNom: "TIR EN SALLE LUSIGNY",
    EprvLieu: "LUSIGNY-SUR-BARSE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025029,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-11-03",
    EprvDateFin: "2024-11-03",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS NOVEMBRE",
    EprvLieu: "OBERNAI",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025030,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-03",
    EprvDateFin: "2024-11-03",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS NOVEMBRE",
    EprvLieu: "OBERNAI",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025031,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-09",
    EprvDateFin: "2024-11-11",
    StructureNom: "NANCY",
    EprvNom: "CONCOURS SALLE NANCY",
    EprvLieu: "NANCY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025032,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-09",
    EprvDateFin: "2024-11-11",
    StructureNom: "CHAOURCE",
    EprvNom: "CONCOURS SALLE CHAOURCE 2024",
    EprvLieu: "CHAOURCE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025033,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-09",
    EprvDateFin: "2024-11-10",
    StructureNom: "RETHEL",
    EprvNom: "TIR SALLE",
    EprvLieu: "RETHEL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025034,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-09",
    EprvDateFin: "2024-11-10",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "2X 18M EN SALLE",
    EprvLieu: "AY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025035,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2024-11-10",
    EprvDateFin: "2024-11-10",
    StructureNom: "EPINAL 1ER",
    EprvNom: "TIR 3 D  - SPINAPARC EPINAL",
    EprvLieu: "EPINAL",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025036,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-10",
    EprvDateFin: "2024-11-10",
    StructureNom: "MULHOUSE STA",
    EprvNom: "TIR EN SALLE 18M",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025037,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2024-11-16",
    EprvDateFin: "2024-11-17",
    StructureNom: "TROYES",
    EprvNom: "DÉBUTANTS",
    EprvLieu: "TROYES",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025038,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-11-16",
    EprvDateFin: "2024-11-17",
    StructureNom: "TROYES",
    EprvNom: "TIR SALLE",
    EprvLieu: "TROYES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025039,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-11-16",
    EprvDateFin: "2024-11-17",
    StructureNom: "REIMS",
    EprvNom: "2X18M DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025040,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-16",
    EprvDateFin: "2024-11-17",
    StructureNom: "HAGONDANGE",
    EprvNom: "TIR SALLE",
    EprvLieu: "HAGONDANGE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025041,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-17",
    EprvDateFin: "2024-11-17",
    StructureNom: "ST DIE",
    EprvNom: "CONCOURS DE TIR À L'ARC EN SALLE",
    EprvLieu: "ST DIE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025042,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-17",
    EprvDateFin: "2024-11-17",
    StructureNom: "TROYES",
    EprvNom: "TIR SALLE",
    EprvLieu: "TROYES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025043,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-16",
    EprvDateFin: "2024-11-17",
    StructureNom: "REIMS",
    EprvNom: "2X18M DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025044,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-16",
    EprvDateFin: "2024-11-17",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "COLOMBEY LES BELLES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025045,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-17",
    EprvDateFin: "2024-11-17",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CHALLENGE D'AUTOMNE",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025046,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-17",
    EprvDateFin: "2024-11-17",
    StructureNom: "STE CROIX ARC CLUB",
    EprvNom: "CONCOURS 2 X 18 M",
    EprvLieu: "STE CROIX EN PLAINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025047,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-11-23",
    EprvDateFin: "2024-11-24",
    StructureNom: "FISMES",
    EprvNom: "CONCOURS SALLE 18 M",
    EprvLieu: "GYMNASE THIBAUT DE CHAMPAGNE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2025048,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-23",
    EprvDateFin: "2024-11-24",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "CONCOURS SALLE SAISON 2024-2025",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025049,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-23",
    EprvDateFin: "2024-11-24",
    StructureNom: "SARREGUEMINES",
    EprvNom: "CONCOURS 18 M",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025050,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-23",
    EprvDateFin: "2024-11-24",
    StructureNom: "BAR SUR SEINE",
    EprvNom: "LA JEAN VILAR",
    EprvLieu: "BAR SUR SEINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025051,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-23",
    EprvDateFin: "2024-11-24",
    StructureNom: "FISMES",
    EprvNom: "CONCOURS SALLE 18 M",
    EprvLieu: "GYMNASE THIBAUT DE CHAMPAGNE",
    InfoSupVal: "2X18M",
    Mandat: false
  },
  {
    EprvId: 2025052,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-11-24",
    EprvDateFin: "2024-11-24",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "COMPÉTITION DES TROIS FRONTIÈRES",
    EprvLieu: "CENTRE SPORTIF RÉGIONAL D'ALSACE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025053,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-24",
    EprvDateFin: "2024-11-24",
    StructureNom: "CD MEUSE",
    EprvNom: "TIR 2X18M BAR LE DUC",
    EprvLieu: "LIGNY EN BARROIS",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025054,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-24",
    EprvDateFin: "2024-11-24",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "COMPÉTITION DES TROIS FRONTIÈRES",
    EprvLieu: "CENTRE SPORTIF RÉGIONAL D'ALSACE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025065,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2024-11-30",
    EprvDateFin: "2024-11-30",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CONCOURS TELETHON",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2025055,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-11-30",
    EprvDateFin: "2024-12-01",
    StructureNom: "GUEUX",
    EprvNom: "TIR EN SALLE GUEUX",
    EprvLieu: "GUEUX",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025056,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2024-11-30",
    EprvDateFin: "2024-11-30",
    StructureNom: "SELESTAT",
    EprvNom: "SPECIAL JEUNES ET ADULTES DEBUTANTS",
    EprvLieu: "SELESTAT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025057,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-30",
    EprvDateFin: "2024-12-01",
    StructureNom: "MAIZIERES GDE PAROISSE",
    EprvNom: "TIR SALLE",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025058,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-30",
    EprvDateFin: "2024-12-01",
    StructureNom: "GUEUX",
    EprvNom: "TIR EN SALLE GUEUX",
    EprvLieu: "GUEUX",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025059,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-11-30",
    EprvDateFin: "2024-11-30",
    StructureNom: "HAYANGE",
    EprvNom: "SALLE 2X25M",
    EprvLieu: "HAYANGE",
    InfoSupVal: "2X25M",
    Mandat: true
  },
  {
    EprvId: 2025060,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-01",
    EprvDateFin: "2024-12-01",
    StructureNom: "HAYANGE",
    EprvNom: "SALLE 2X18M 2 DÉPARTS",
    EprvLieu: "HAYANGE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025061,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-01",
    EprvDateFin: "2024-12-01",
    StructureNom: "SELESTAT",
    EprvNom: "CONCOURS SELECTIF",
    EprvLieu: "SELESTAT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025062,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-12-02",
    EprvDateFin: "2024-12-02",
    StructureNom: "HEILLECOURT",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025066,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-12-07",
    EprvDateFin: "2024-12-08",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TIR SALLE MONTIGNY",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025067,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-07",
    EprvDateFin: "2024-12-08",
    StructureNom: "CONFLANS EN JARNISY",
    EprvNom: "CONCOURS CONFLANS EN JARNISY",
    EprvLieu: "CONFLANS EN JARNISY",
    InfoSupVal: "2X25M + 2X18M",
    Mandat: true
  },
  {
    EprvId: 2025068,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-07",
    EprvDateFin: "2024-12-08",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TIR SALLE MONTIGNY",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025069,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-07",
    EprvDateFin: "2024-12-08",
    StructureNom: "VAUCHONVILLIERS",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "COSEC VENDEUVRE SUR BARSE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025070,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-07",
    EprvDateFin: "2024-12-08",
    StructureNom: "BETTANCOURT LA FERREE",
    EprvNom: "CONCOURS SALLE 2X18 BETTANCOURT-LA-FERRÉE",
    EprvLieu: "BETTANCOURT-LA-FERRÉE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025071,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2024-12-08",
    EprvDateFin: "2024-12-08",
    StructureNom: "MULHOUSE STA",
    EprvNom: "CHALLENGE US",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Challenge par équipe",
    Mandat: true
  },
  {
    EprvId: 2025072,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-08",
    EprvDateFin: "2024-12-08",
    StructureNom: "VANDOEUVRE",
    EprvNom: "**Annulé** 41ÈME CHALLENGE DE VANDOEUVRE **Annulé**",
    EprvLieu: "VANDOEUVRE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025073,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-08",
    EprvDateFin: "2024-12-08",
    StructureNom: "VITTEL",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "VITTEL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025074,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2024-12-14",
    EprvDateFin: "2024-12-14",
    StructureNom: "ST NICOLAS DE PORT",
    EprvNom: "LES ARCHERS PORTOIS",
    EprvLieu: "ST NICOLAS DE PORT 54210",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025075,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2024-12-14",
    EprvDateFin: "2024-12-14",
    StructureNom: "OBERNAI",
    EprvNom: "TROPHÉE DES LUTINS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025076,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-12-14",
    EprvDateFin: "2024-12-15",
    StructureNom: "EPERNAY",
    EprvNom: "CONCOURS SELECTIF SALLE",
    EprvLieu: "EPERNAY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025077,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-14",
    EprvDateFin: "2024-12-15",
    StructureNom: "MARLY POURNOY",
    EprvNom: "CD57 JEUNES",
    EprvLieu: "MARLY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025078,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-14",
    EprvDateFin: "2024-12-15",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR SALLE 2025",
    EprvLieu: "BAR SUR AUBE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025079,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-14",
    EprvDateFin: "2024-12-15",
    StructureNom: "EPERNAY",
    EprvNom: "CONCOURS SELECTIF SALLE",
    EprvLieu: "EPERNAY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025080,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2024-12-15",
    EprvDateFin: "2024-12-15",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS DE NOEL",
    EprvLieu: "OBERNAI",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025081,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-15",
    EprvDateFin: "2024-12-15",
    StructureNom: "ST NICOLAS DE PORT",
    EprvNom: "LES ARCHERS PORTOIS",
    EprvLieu: "ST NICOLAS DE PORT 54210",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025082,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2024-12-15",
    EprvDateFin: "2024-12-15",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS DE NOEL",
    EprvLieu: "OBERNAI",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025084,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-04",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS AMICAL DEBUTANTS",
    EprvLieu: "VARANGEVILLE ",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025085,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-05",
    StructureNom: "ARCIS SUR AUBE",
    EprvNom: "CONCOURS SALLE ",
    EprvLieu: "ARCIS SUR AUBE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025086,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-05",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "TIR À 18M",
    EprvLieu: "ARS SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025098,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-05",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CHALLENGE DE LA NOUVELLE ANNÉE",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025087,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-05",
    StructureNom: "ARCIS SUR AUBE",
    EprvNom: "CONCOURS SALLE ",
    EprvLieu: "ARCIS SUR AUBE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025088,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-05",
    StructureNom: "STE MENEHOULD",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "SAINTE MENEHOULD",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025089,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-04",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS SPECIALE FEMMES",
    EprvLieu: "VARANGEVILLE  ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025090,
    ChampionnatId: 10,
    ChampionnatLibelle: "Tournoi Poussin",
    EprvDateDebut: "2025-01-04",
    EprvDateFin: "2025-01-04",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS SPECIAL U11 ET U13",
    EprvLieu: "VARANGEVILLE ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025091,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-05",
    EprvDateFin: "2025-01-05",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS ANNUEL 2025",
    EprvLieu: "VARANGEVILLE  ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025092,
    ChampionnatId: 1,
    ChampionnatLibelle: "Divers",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-11",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "25M SALLE RUE DE LA GARONNE",
    EprvLieu: "HAUCOURT ST CHARLES",
    InfoSupVal: "Challenge Individuel",
    Mandat: true
  },
  {
    EprvId: 2025093,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-11",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "AMICAL 18 M SALLE HAUCOURT MOULAINE",
    EprvLieu: "HAUCOURT ST CHARLES",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025094,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-11",
    StructureNom: "REIMS",
    EprvNom: "CONCOURS JEUNES DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "Jeunes débutants",
    Mandat: false
  },
  {
    EprvId: 2025095,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-11",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "SPÉCIAL JEUNES DECOUVERTE ADULTES",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025096,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-11",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI DÉBUTANTS JEUNES ET ADULTES",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025097,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-12",
    StructureNom: "THAON LES VOSGES",
    EprvNom: "TIR À 18M",
    EprvLieu: "THAON LES VOSGES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025099,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-12",
    StructureNom: "COLMAR",
    EprvNom: "TIR EN SALLE 18M",
    EprvLieu: "COLMAR",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025100,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-11",
    EprvDateFin: "2025-01-12",
    StructureNom: "EINVILLE",
    EprvNom: "CONCOURS SALLE 2025 EINVILLE",
    EprvLieu: "EINVILLE",
    InfoSupVal: "4X18M",
    Mandat: true
  },
  {
    EprvId: 2025101,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-12",
    EprvDateFin: "2025-01-12",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "18 M OFFICIEL SALLE DE SPORTS",
    EprvLieu: "HAUCOURT ST CHARLES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025102,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-12",
    EprvDateFin: "2025-01-12",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CONCOURS INDIVIDUEL",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025103,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-01-13",
    EprvDateFin: "2025-01-13",
    StructureNom: "HEILLECOURT",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025104,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-13",
    EprvDateFin: "2025-01-13",
    StructureNom: "HEILLECOURT",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025105,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-18",
    StructureNom: "BRUMATH",
    EprvNom: "SPÉCIAL JEUNES ET ADULTES DEBUTANTS",
    EprvLieu: "BRUMATH",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025106,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-19",
    StructureNom: "FISMES",
    EprvNom: "CHAMPIONNAT DE RONDE SALLE",
    EprvLieu: "FISMES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2025107,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-18",
    StructureNom: "HEILLECOURT",
    EprvNom: "TIR EN SALLE - CR PARA-TIR",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025108,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-19",
    StructureNom: "CD AUBE",
    EprvNom: "CHAMPIONNAT AUBE SALLE",
    EprvLieu: "CHAOURCE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025109,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-19",
    StructureNom: "NEUFCHATEAU",
    EprvNom: "CONCOURS SALLE SUPPORT CD 88",
    EprvLieu: "NEUFCHATEAU",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025110,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-19",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES SALLE 2025",
    EprvLieu: "SUIPPES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025111,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-19",
    StructureNom: "FISMES",
    EprvNom: "CHAMPIONNAT DE RONDE SALLE",
    EprvLieu: "FISMES",
    InfoSupVal: "2X18M",
    Mandat: false
  },
  {
    EprvId: 2025112,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-18",
    EprvDateFin: "2025-01-18",
    StructureNom: "HEILLECOURT",
    EprvNom: "TIR EN SALLE - CR PARA-TIR",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025113,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-19",
    EprvDateFin: "2025-01-19",
    StructureNom: "BRUMATH",
    EprvNom: "COMPETITION SALLE 2X18M",
    EprvLieu: "BRUMATH",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025114,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-19",
    EprvDateFin: "2025-01-19",
    StructureNom: "VOLGELSHEIM",
    EprvNom: "CHAMPIONNAT HAUT-RHIN SALLE",
    EprvLieu: "VOLGELSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025115,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-25",
    EprvDateFin: "2025-01-26",
    StructureNom: "CD ARDENNES",
    EprvNom: "CD SALLE",
    EprvLieu: "SEDAN",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025116,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-25",
    EprvDateFin: "2025-01-26",
    StructureNom: "CD MARNE",
    EprvNom: "CD 51",
    EprvLieu: "CHALONS EN CHAMPAGNE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025117,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-25",
    EprvDateFin: "2025-01-26",
    StructureNom: "TOUL",
    EprvNom: "CONCOURS SALLE TOUL CD ADULTES",
    EprvLieu: "TOUL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025118,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-25",
    EprvDateFin: "2025-01-26",
    StructureNom: "FAREBERSVILLER",
    EprvNom: "CD 57",
    EprvLieu: "FARÉBERSVILLER ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025119,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-25",
    EprvDateFin: "2025-01-25",
    StructureNom: "TOUL",
    EprvNom: "CONCOURS SALLE TOUL CD JEUNES",
    EprvLieu: "TOUL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025120,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-01-26",
    EprvDateFin: "2025-01-26",
    StructureNom: "WISSEMBOURG",
    EprvNom: "CHAMPIONNAT DEPARTEMENTAL 67 SALLE",
    EprvLieu: "WISSEMBOURG",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025121,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-02-01",
    EprvDateFin: "2025-02-02",
    StructureNom: "CD AUBE",
    EprvNom: "CHAMPIONNAT RÉGIONAL GRAND EST",
    EprvLieu: "SAINT-JULIEN-LES-VILLAS",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025122,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-02-08",
    EprvDateFin: "2025-02-09",
    StructureNom: "PONT A MOUSSON",
    EprvNom: "T€AM'S 2025",
    EprvLieu: "PONT-A-MOUSSON",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025123,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2025-02-08",
    EprvDateFin: "2025-02-08",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "LOISIRS JEUNES",
    EprvLieu: "AY CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025124,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-02-08",
    EprvDateFin: "2025-02-09",
    StructureNom: "PONT A MOUSSON",
    EprvNom: "T€AM'S 2025",
    EprvLieu: "PONT-AMOUSSON",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025125,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-02-08",
    EprvDateFin: "2025-02-09",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI SCRATCH 18M AVEC FINALES",
    EprvLieu: "COLMAR",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025126,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-02-15",
    EprvDateFin: "2025-02-16",
    StructureNom: "PONT A MOUSSON",
    EprvNom: "T€AM'S DOUBLE MIXTE",
    EprvLieu: "PONT-À-MOUSSON",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025127,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-02-15",
    EprvDateFin: "2025-02-16",
    StructureNom: "PONT A MOUSSON",
    EprvNom: "T€AM'S DOUBLE MIXTE",
    EprvLieu: "PONT-À-MOUSSON",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025128,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-02-16",
    EprvDateFin: "2025-02-16",
    StructureNom: "BRUNSTATT",
    EprvNom: "CONCOURS SELECTIF ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025129,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-02-23",
    EprvDateFin: "2025-02-23",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "COMPÉTITION SALLE 2X18M + FINALES",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2025130,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-03-01",
    EprvDateFin: "2025-03-02",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "CONCOURS AMICAL",
    EprvLieu: "COLOMBEY LES BELLES",
    InfoSupVal: "Tir à l Arc au Féminin",
    Mandat: true
  },
  {
    EprvId: 2025131,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-03-02",
    EprvDateFin: "2025-03-02",
    StructureNom: "MULHOUSE STA",
    EprvNom: "TROPHÉE DES MIXTES DEPARTEMENTAL",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Trophée des mixtes",
    Mandat: true
  },
  {
    EprvId: 2025132,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2025-03-08",
    EprvDateFin: "2025-03-08",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "CONCOURS JEUNES",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2025133,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-03-22",
    EprvDateFin: "2025-03-22",
    StructureNom: "OBERNAI",
    EprvNom: "TROPHEE DU PRINTEMPS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025134,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-03-30",
    EprvDateFin: "2025-03-30",
    StructureNom: "CHAOURCE",
    EprvNom: "CONCOURS 3D CHAOURCE",
    EprvLieu: "LES LOGES MARGUERONS",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025135,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-04-05",
    EprvDateFin: "2025-04-05",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "SPÉCIAL JEUNES ET DÉCOUVERTE ADULTES",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "Jeunes débutants",
    Mandat: true
  },
  {
    EprvId: 2025136,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-04-06",
    EprvDateFin: "2025-04-06",
    StructureNom: "REIMS",
    EprvNom: "TIR 3D DE REIMS",
    EprvLieu: "FORT DE FRESNE LES REIMS",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025137,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-04-12",
    EprvDateFin: "2025-04-13",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR EN CAMPAGNE",
    EprvLieu: "LAFERTE SUR AUBE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES Repiqueté",
    Mandat: true
  },
  {
    EprvId: 2025138,
    ChampionnatId: 14,
    ChampionnatLibelle: "Run archery",
    EprvDateDebut: "2025-04-13",
    EprvDateFin: "2025-04-13",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "RUN ARCHERY",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "Run Archery",
    Mandat: true
  },
  {
    EprvId: 2025139,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2025-04-13",
    EprvDateFin: "2025-04-13",
    StructureNom: "EPINAL 1ER",
    EprvNom: "TIR NATURE EPINAL  ( 2 DÉPARTS)",
    EprvLieu: "EPINAL",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025140,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-04-19",
    EprvDateFin: "2025-04-19",
    StructureNom: "TROYES",
    EprvNom: "DÉBUTANTS TAE",
    EprvLieu: "SAINT PARRES AUX TERTRES",
    InfoSupVal: "Débutants",
    Mandat: false
  },
  {
    EprvId: 2025141,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-04-19",
    EprvDateFin: "2025-04-20",
    StructureNom: "TROYES",
    EprvNom: "TAE PARA",
    EprvLieu: "SAINT PARRES AUX TERTRES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025142,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-04-19",
    EprvDateFin: "2025-04-20",
    StructureNom: "TROYES",
    EprvNom: "TAE-DRE-TROYES",
    EprvLieu: "SAINT PARRES AUX TERTRES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025143,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-04-19",
    EprvDateFin: "2025-04-20",
    StructureNom: "TROYES",
    EprvNom: "TAE-DRE-TROYES",
    EprvLieu: "SAINT PARRES AUX TERTRES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025144,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2025-04-19",
    EprvDateFin: "2025-08-31",
    StructureNom: "ECLARON",
    EprvNom: "BEURSAULT ECLARON 2025",
    EprvLieu: "ECLARON",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2025146,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2025-04-19",
    EprvDateFin: "2025-08-24",
    StructureNom: "FISMES",
    EprvNom: "TIR BEURSAULT 2025",
    EprvLieu: "JEU D ARC DE FISMES",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2025147,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2025-04-21",
    EprvDateFin: "2025-09-07",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "TIR  BEURSAULT",
    EprvLieu: "MONT L'ETROIT",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2025148,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-04-26",
    EprvDateFin: "2025-04-26",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "TOURNOI DEBUTANT EXTERIEUR 2025",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025149,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-04-26",
    EprvDateFin: "2025-04-26",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "TIR LOISIRS DECOUVERTE BLASONS",
    EprvLieu: "LA VEUVE",
    InfoSupVal: "Jeux du tir à l'arc",
    Mandat: true
  },
  {
    EprvId: 2025150,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2025-04-26",
    EprvDateFin: "2025-08-31",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TIR BEURSAULT",
    EprvLieu: "BRIENNE LE CHÂTEAU ",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2025151,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-04-26",
    EprvDateFin: "2025-04-26",
    StructureNom: "GUEUX",
    EprvNom: "TIR EN CAMPAGNE FORT DE MONTBRÉ",
    EprvLieu: "FORT DE MONTBRÉ TAISSY",
    InfoSupVal: "12 CONNUES + 12 INCONNUES Repiqueté",
    Mandat: true
  },
  {
    EprvId: 2025152,
    ChampionnatId: 10,
    ChampionnatLibelle: "Tournoi Poussin",
    EprvDateDebut: "2025-04-26",
    EprvDateFin: "2025-04-26",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "TOURNOI POUSSINS",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025153,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-04-27",
    EprvDateFin: "2025-04-27",
    StructureNom: "VERDUN",
    EprvNom: " TIR 3D CD 55",
    EprvLieu: "VERDUN",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025154,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-04-27",
    EprvDateFin: "2025-04-27",
    StructureNom: "MAIZIERES GDE PAROISSE",
    EprvNom: "CONCOURS 3D  ARCHERS ETOILE",
    EprvLieu: "MARIGNY LE CHATEL",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025155,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-04-27",
    EprvDateFin: "2025-04-27",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "TAE 2025",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025156,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-04-27",
    EprvDateFin: "2025-04-27",
    StructureNom: "GUEUX",
    EprvNom: "TIR EN CAMPAGNE",
    EprvLieu: "FORT DE MONTBRÉ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES Repiqueté",
    Mandat: true
  },
  {
    EprvId: 2025157,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2025-04-28",
    EprvDateFin: "2025-06-27",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "BEURSAULT",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2025158,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-05-01",
    EprvDateFin: "2025-05-01",
    StructureNom: "BRUNSTATT",
    EprvNom: "TAE DU MUGUET ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025159,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-01",
    EprvDateFin: "2025-05-01",
    StructureNom: "BRUNSTATT",
    EprvNom: "TAE DU MUGUET ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025160,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-05-01",
    EprvDateFin: "2025-05-01",
    StructureNom: "SARREGUEMINES",
    EprvNom: "TIR CAMPAGNE DU BUCHHOLZ CD57",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025161,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2025-05-01",
    EprvDateFin: "2025-05-01",
    StructureNom: "PONT ST VINCENT",
    EprvNom: "1ER MAI À PONT SAINT VINCENT",
    EprvLieu: "PONT SAINT VINCENT",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025162,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-03",
    EprvDateFin: "2025-05-04",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR EXTÉRIEUR",
    EprvLieu: "VILLE SOUS LA FERTE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025163,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-03",
    EprvDateFin: "2025-05-04",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE DE PRINTEMPS 2025",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025164,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-05-04",
    EprvDateFin: "2025-05-04",
    StructureNom: "THANN",
    EprvNom: "CAMPAGNE DU RANGEN",
    EprvLieu: "THANN",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025165,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2025-05-10",
    EprvDateFin: "2025-05-10",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "**Annulé** JEUNE **Annulé**",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: false
  },
  {
    EprvId: 2025166,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-05-10",
    EprvDateFin: "2025-05-11",
    StructureNom: "SARREBOURG",
    EprvNom: "CONCOURS 3D - CD57 - 3 DÉPARTS",
    EprvLieu: "LETTENBACH (ABRESCHVILLER)",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025167,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-10",
    EprvDateFin: "2025-05-11",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "TAE SAISON 2025",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025168,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-10",
    EprvDateFin: "2025-05-11",
    StructureNom: "BOULIGNY",
    EprvNom: "TAE N ET TAE I SUPPORT CD 55",
    EprvLieu: "BOULIGNY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025169,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-10",
    EprvDateFin: "2025-05-10",
    StructureNom: "CD MARNE",
    EprvNom: "CHAMPIONNAT DE LIGUE NORD EST FCD",
    EprvLieu: "MOURMELON LE GRAND",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2025170,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-05-10",
    EprvDateFin: "2025-05-11",
    StructureNom: "VERTUS",
    EprvNom: "CIRCUIT DES 5 NATIONS",
    EprvLieu: "VERTUS",
    InfoSupVal: "(12 CONNUES + 12 INCONNUES) X2 Repiqueté",
    Mandat: true
  },
  {
    EprvId: 2025171,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-05-11",
    EprvDateFin: "2025-05-11",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "TAE I ET N",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025172,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-11",
    EprvDateFin: "2025-05-11",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "TAE I ET N",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025173,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-11",
    EprvDateFin: "2025-05-11",
    StructureNom: "VAGNEY",
    EprvNom: "CONCOURS SELECTIF CHAMPIONNAT DE FRANCE ",
    EprvLieu: "VAGNEY ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025174,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-17",
    EprvDateFin: "2025-05-18",
    StructureNom: "BETTANCOURT LA FERREE",
    EprvNom: "CONCOURS TAEI & TAEN BETTANCOURT-LA-FERRÉE",
    EprvLieu: "BETTANCOURT-LA-FERRÉE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025175,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-18",
    EprvDateFin: "2025-05-18",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TAE I+N \/ DRE2",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025176,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-18",
    EprvDateFin: "2025-05-18",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TAE I+N \/ DRE2",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025177,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-18",
    EprvDateFin: "2025-05-18",
    StructureNom: "RETHEL",
    EprvNom: "TIR EXTÉRIEUR",
    EprvLieu: "RETHEL",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025178,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-05-18",
    EprvDateFin: "2025-05-18",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "TIR CAMPAGNE",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025179,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2025-05-18",
    EprvDateFin: "2025-05-18",
    StructureNom: "GORZE",
    EprvNom: "NATURE GORZE - CR & CD57",
    EprvLieu: "GORZE",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025180,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-24",
    EprvDateFin: "2025-05-25",
    StructureNom: "CHAOURCE",
    EprvNom: "CONCOURS EXTERIEUR 2025",
    EprvLieu: "CHAOURCE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025181,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-05-25",
    EprvDateFin: "2025-05-25",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "TIR 3D À ROZÉRIEULLES",
    EprvLieu: "ROZERIEULLES",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025183,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-05-29",
    EprvDateFin: "2025-05-29",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "TIR EN CAMPAGNE 2025 CHÂTEAU À CONS LA GRANDVILLE",
    EprvLieu: "CONS LA GRANDVILLE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025184,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-05-31",
    EprvDateFin: "2025-05-31",
    StructureNom: "EINVILLE",
    EprvNom: "TOURNOI DÉPARTEMENTAL JEUNES",
    EprvLieu: "EINVILLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2025185,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2025-05-31",
    EprvDateFin: "2025-06-22",
    StructureNom: "EINVILLE",
    EprvNom: "CONCOURS BEURSAULT",
    EprvLieu: "EINVILLE",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2025186,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-01",
    EprvDateFin: "2025-06-01",
    StructureNom: "EINVILLE",
    EprvNom: "TAE I ET TAE N",
    EprvLieu: "EINVILLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025999,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-06-01",
    EprvDateFin: "2025-06-01",
    StructureNom: "BREUX",
    EprvNom: "Tir 3D",
    EprvLieu: "BREUX",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025187,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-01",
    EprvDateFin: "2025-06-01",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR CAMPAGNE PARA-VALIDES",
    EprvLieu: "ARCIS SUR AUBE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025188,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-06-07",
    EprvDateFin: "2025-06-07",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI DÉBUTANTS JEUNES ET ADULTES AVEC FINALES",
    EprvLieu: "COLMAR",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2025189,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-07",
    EprvDateFin: "2025-06-08",
    StructureNom: "DIEUZE",
    EprvNom: "DIEUZE TAEN-TAEI CD57",
    EprvLieu: "DIEUZE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025190,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-07",
    EprvDateFin: "2025-06-07",
    StructureNom: "VAGNEY",
    EprvNom: "CONCOURS SELECTIF CAMPAGNE ",
    EprvLieu: "VAGNEY ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES Repiqueté",
    Mandat: true
  },
  {
    EprvId: 2025191,
    ChampionnatId: 10,
    ChampionnatLibelle: "Tournoi Poussin",
    EprvDateDebut: "2025-06-07",
    EprvDateFin: "2025-06-07",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI U11",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025192,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-06-08",
    EprvDateFin: "2025-06-08",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES TAE 2025",
    EprvLieu: "SOMME SUIPPE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025182,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-06-08",
    EprvDateFin: "2025-06-08",
    StructureNom: "PONT ST VINCENT",
    EprvNom: "3D",
    EprvLieu: "PONT SAINT VINCENT",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025193,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-06-08",
    EprvDateFin: "2025-06-08",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "TIR 3D",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025194,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-08",
    EprvDateFin: "2025-06-09",
    StructureNom: "COLMAR",
    EprvNom: "TAE COLMAR 2025",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025195,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-08",
    EprvDateFin: "2025-06-08",
    StructureNom: "BAR SUR SEINE",
    EprvNom: "LA JEAN VILAR",
    EprvLieu: "BAR SUR SEINE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025196,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-08",
    EprvDateFin: "2025-06-08",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES TAE 2025",
    EprvLieu: "SOMME SUIPPE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025197,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-08",
    EprvDateFin: "2025-06-08",
    StructureNom: "VAGNEY",
    EprvNom: "CONCOURS SELECTIF CAMPAGNE ",
    EprvLieu: "VAGNEY ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025198,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-06-14",
    EprvDateFin: "2025-06-15",
    StructureNom: "BRUNSTATT",
    EprvNom: "TAE DE JUIN ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025199,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-14",
    EprvDateFin: "2025-06-15",
    StructureNom: "BRUNSTATT",
    EprvNom: "TAE DE JUIN ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025200,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-14",
    EprvDateFin: "2025-06-14",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "CD AUBE TIR EN CAMPAGNE",
    EprvLieu: "LAFERTE SUR AUBE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025201,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-06-15",
    EprvDateFin: "2025-06-15",
    StructureNom: "REIMS",
    EprvNom: "TAE REIMS",
    EprvLieu: "BETHENY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025202,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-06-15",
    EprvDateFin: "2025-06-15",
    StructureNom: "GORZE",
    EprvNom: "3D - GORZE",
    EprvLieu: "GORZE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025203,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-15",
    EprvDateFin: "2025-06-15",
    StructureNom: "REIMS",
    EprvNom: "TAE REIMS",
    EprvLieu: "BETHENY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025204,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-15",
    EprvDateFin: "2025-06-15",
    StructureNom: "VITTEL",
    EprvNom: "TAEIN",
    EprvLieu: "VITTEL",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025300,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-14",
    EprvDateFin: "2025-06-15",
    StructureNom: "LONGUEVAL",
    EprvNom: "TAE N",
    EprvLieu: "BEAURIEUX (02)",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025205,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-15",
    EprvDateFin: "2025-06-15",
    StructureNom: "TOUL",
    EprvNom: "TIR CAMPAGNE - TOUL",
    EprvLieu: "PAGNEY DERRIERE BARINE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025206,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-15",
    EprvDateFin: "2025-06-15",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "CR GRAND EST TIR EN CAMPAGNE",
    EprvLieu: "LAFERTE SUR AUBE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025207,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-06-21",
    EprvDateFin: "2025-06-22",
    StructureNom: "ST DIE",
    EprvNom: "CONCOURS TAE",
    EprvLieu: "ST DIE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025208,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-21",
    EprvDateFin: "2025-06-22",
    StructureNom: "ST DIE",
    EprvNom: "CONCOURS TAE",
    EprvLieu: "ST DIE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025209,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-21",
    EprvDateFin: "2025-06-21",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TIR EN EXTERIEUR  ",
    EprvLieu: "BRIENNE LE CHÂTEAU ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025210,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-06-22",
    EprvDateFin: "2025-06-22",
    StructureNom: "SAINT DIZIER",
    EprvNom: "TIR 3 D DE SAINT-DIZIER",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025211,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-22",
    EprvDateFin: "2025-06-22",
    StructureNom: "VOLGELSHEIM",
    EprvNom: "3ÈME MANCHE DRE",
    EprvLieu: "VOLGELSHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025212,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-22",
    EprvDateFin: "2025-06-22",
    StructureNom: "VOLGELSHEIM",
    EprvNom: "3ÈME MANCHE DRE",
    EprvLieu: "VOLGELSHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025213,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-22",
    EprvDateFin: "2025-06-22",
    StructureNom: "NANCY",
    EprvNom: "CAMPAGNE DE NANCY-LAXOU",
    EprvLieu: "NANCY-LAXOU",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025214,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-06-28",
    EprvDateFin: "2025-06-28",
    StructureNom: "REIMS",
    EprvNom: "CHALLENGES D'ÉTÉ",
    EprvLieu: "BETHENY",
    InfoSupVal: "Jeux du tir à l'arc",
    Mandat: false
  },
  {
    EprvId: 2025215,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-28",
    EprvDateFin: "2025-06-29",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE D'ETE",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025299,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-06-29",
    EprvDateFin: "2025-06-29",
    StructureNom: "SEICHAMPS",
    EprvNom: "CR PARA-TAE",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025216,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-28",
    EprvDateFin: "2025-06-29",
    StructureNom: "THAON LES VOSGES",
    EprvNom: "TAE ",
    EprvLieu: "THAON",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025217,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-06-29",
    EprvDateFin: "2025-06-29",
    StructureNom: "HAYANGE",
    EprvNom: "3D - 2 DEPARTS",
    EprvLieu: "HAYANGE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025218,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-29",
    EprvDateFin: "2025-06-29",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "TAE-LINGOLSHEIM",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025219,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-06-29",
    EprvDateFin: "2025-06-29",
    StructureNom: "MARLY POURNOY",
    EprvNom: "CR TAEN",
    EprvLieu: "MARLY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025220,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-06-29",
    EprvDateFin: "2025-06-29",
    StructureNom: "VERTUS",
    EprvNom: "VERTUS TIR EN CAMPAGNE",
    EprvLieu: "VERTUS",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2025221,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2025-07-06",
    EprvDateFin: "2025-07-06",
    StructureNom: "ARCIS SUR AUBE",
    EprvNom: "CONCOURS TAE",
    EprvLieu: "ARCIS SUR AUBE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025222,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-07-06",
    EprvDateFin: "2025-07-06",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "3D DE MONTIGNY",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025223,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-07-06",
    EprvDateFin: "2025-07-06",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "CR TAE I",
    EprvLieu: "WALDECK - MULHOUSE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025224,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2025-07-06",
    EprvDateFin: "2025-07-06",
    StructureNom: "ARCIS SUR AUBE",
    EprvNom: "CONCOURS TAE",
    EprvLieu: "ARCIS SUR AUBE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2025225,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-07-12",
    EprvDateFin: "2025-07-13",
    StructureNom: "GUEUX",
    EprvNom: "TIR 3D FORT DE MONTBRÉ",
    EprvLieu: "FORT DE MONTBRÉ",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2025226,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2025-08-31",
    EprvDateFin: "2025-08-31",
    StructureNom: "VAGNEY",
    EprvNom: "TIR NATURE DE VAGNEY ",
    EprvLieu: "VAGNEY ",
    InfoSupVal: "21 CIBLES",
    Mandat: false
  },
  {
    EprvId: 2025227,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2025-08-31",
    EprvDateFin: "2025-08-31",
    StructureNom: "VAGNEY",
    EprvNom: "PARCOURS NATURE ",
    EprvLieu: "VAGNEY ",
    InfoSupVal: "21 CIBLES",
    Mandat: false
  },
  {
    EprvId: 2026001,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2025-09-06",
    EprvDateFin: "2025-09-07",
    StructureNom: "SARREGUEMINES",
    EprvNom: "TIR CAMPAGNE DU MOULIN DES FAÏENCIERS ",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES Repiqueté",
    Mandat: true
  },
  {
    EprvId: 2026002,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-09-13",
    EprvDateFin: "2025-09-13",
    StructureNom: "VARANGEVILLE",
    EprvNom: "LOISIR DECOUVERTE 3D",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026003,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-09-14",
    EprvDateFin: "2025-09-14",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS 3D - CD 54 - 2026",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026004,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2025-09-21",
    EprvDateFin: "2025-09-21",
    StructureNom: "GORZE",
    EprvNom: "NATURE GORZE - SEPT 2025 - 2 DEPARTS",
    EprvLieu: "GORZE",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026005,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-09-28",
    EprvDateFin: "2025-09-28",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "CONCOURS 3D",
    EprvLieu: "GORCY",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026006,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-04",
    EprvDateFin: "2025-10-05",
    StructureNom: "RETHEL",
    EprvNom: "TIR SALLE",
    EprvLieu: "RETHEL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026007,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-10-08",
    EprvDateFin: "2025-10-08",
    StructureNom: "NANCY",
    EprvNom: "PARTAGE TES FLÈCHES",
    EprvLieu: "NANCY",
    InfoSupVal: "Partage tes flèches",
    Mandat: false
  },
  {
    EprvId: 2026008,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2025-10-11",
    EprvDateFin: "2025-10-11",
    StructureNom: "SAINT DIZIER",
    EprvNom: "RENCONTRE JEUNES ET DEBUTANTS",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2026009,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-11",
    EprvDateFin: "2025-10-12",
    StructureNom: "SARREBOURG",
    EprvNom: "CONCOURS D'AUTOMNE 2X18M 3 DEPARTS",
    EprvLieu: "SARREBOURG",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026010,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-10-12",
    EprvDateFin: "2025-10-12",
    StructureNom: "SAINT DIZIER",
    EprvNom: "TIR EN SALLE DE SAINT-DIZIER",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026011,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-12",
    EprvDateFin: "2025-10-12",
    StructureNom: "SAINT DIZIER",
    EprvNom: "TIR EN SALLE DE SAINT-DIZIER",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026012,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-18",
    EprvDateFin: "2025-10-19",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TIR A 18M",
    EprvLieu: "BRIENNE LE CHATEAU",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026013,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-18",
    EprvDateFin: "2025-10-19",
    StructureNom: "VERTUS BLANCS COTEAUX",
    EprvNom: "CONCOURS EN SALLE",
    EprvLieu: "VERTUS BLANCS COTEAUX",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026014,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-18",
    EprvDateFin: "2025-10-19",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CHALLENGE AUTOMNE",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026015,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-18",
    EprvDateFin: "2025-10-19",
    StructureNom: "CREUTZWALD",
    EprvNom: "SÉLECTIF FRANCE",
    EprvLieu: "CREUTZWALD",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026016,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-10-19",
    EprvDateFin: "2025-10-19",
    StructureNom: "WISSEMBOURG",
    EprvNom: "CONCOURS SELECTIF EN SALLE",
    EprvLieu: "WISSEMBOURG",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026017,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-19",
    EprvDateFin: "2025-10-19",
    StructureNom: "WISSEMBOURG",
    EprvNom: "CONCOURS SELECTIF EN SALLE",
    EprvLieu: "WISSEMBOURG",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026018,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-10-25",
    EprvDateFin: "2025-10-26",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026019,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-25",
    EprvDateFin: "2025-10-26",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026020,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-25",
    EprvDateFin: "2025-10-26",
    StructureNom: "BOULIGNY",
    EprvNom: "TIR À 18 M",
    EprvLieu: "BOULIGNY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026021,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-25",
    EprvDateFin: "2025-10-26",
    StructureNom: "ROMILLY SUR SEINE",
    EprvNom: "SALLE 2X18M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026022,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-25",
    EprvDateFin: "2025-10-26",
    StructureNom: "FOLSCHVILLER",
    EprvNom: "CONCOURS SELECTIF INDIVIDUEL",
    EprvLieu: "FOLSCHVILLER",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026023,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-10-25",
    EprvDateFin: "2025-10-26",
    StructureNom: "CHAUMONT",
    EprvNom: "TIR EN SALLE DE CHAUMONT",
    EprvLieu: "CHAUMONT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026024,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2025-10-26",
    EprvDateFin: "2025-10-26",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "CONCOURS NATURE CD 67",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026025,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-11-01",
    EprvDateFin: "2025-11-02",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS NOVEMBRE - 4 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026026,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-11-01",
    EprvDateFin: "2025-11-02",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE D'AUTOMNE 2025",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026027,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-01",
    EprvDateFin: "2025-11-02",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS NOVEMBRE - 4 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026028,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-01",
    EprvDateFin: "2025-11-02",
    StructureNom: "VENDEUVRE SUR BARSE",
    EprvNom: "TIR EN SALLE LUSIGNY",
    EprvLieu: "LUSIGNY-SUR-BARSE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026029,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-01",
    EprvDateFin: "2025-11-02",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE D'AUTOMNE 2025",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026030,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-01",
    EprvDateFin: "2025-11-02",
    StructureNom: "HETTANGE GRANDE",
    EprvNom: "CONCOURS SELECTIF VILLE DE HETTANGE GRANDE",
    EprvLieu: "HETTANGE GRANDE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026031,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-11-08",
    EprvDateFin: "2025-11-09",
    StructureNom: "ST DIE",
    EprvNom: "TIR À 18M",
    EprvLieu: "ST DIÉ DES VOSGES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026032,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-08",
    EprvDateFin: "2025-11-09",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "AY CHAMPAGNE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026033,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-08",
    EprvDateFin: "2025-11-09",
    StructureNom: "RETHEL",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "RETHEL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026034,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-08",
    EprvDateFin: "2025-11-09",
    StructureNom: "CHAOURCE",
    EprvNom: "CONCOURS SALLE 2025",
    EprvLieu: "COSEC DE CHAOURCE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026035,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-08",
    EprvDateFin: "2025-11-09",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "COLOMBEY LES BELLES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026036,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-08",
    EprvDateFin: "2025-11-09",
    StructureNom: "ST DIE",
    EprvNom: "TIR À 18M",
    EprvLieu: "ST DIÉ DES VOSGES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026037,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2025-11-09",
    EprvDateFin: "2025-11-09",
    StructureNom: "EPINAL 1ER",
    EprvNom: "3D DE SPINAPARC",
    EprvLieu: "EPINAL",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026038,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-09",
    EprvDateFin: "2025-11-09",
    StructureNom: "STE CROIX ARC CLUB",
    EprvNom: "2 X 18 M SÉLÉCTIF",
    EprvLieu: "SAINTE CROIX EN PLAINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026039,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-11-11",
    EprvDateFin: "2025-11-11",
    StructureNom: "NANCY",
    EprvNom: "RENCONTRE AMICALE",
    EprvLieu: "NANCY",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026040,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-11-11",
    EprvDateFin: "2025-11-11",
    StructureNom: "NANCY",
    EprvNom: "TIR AU FÉMININ",
    EprvLieu: "NANCY",
    InfoSupVal: "Tir à l Arc au Féminin",
    Mandat: true
  },
  {
    EprvId: 2026041,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-11-15",
    EprvDateFin: "2025-11-15",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "PARTAGE TES FLECHES",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Partage tes flèches",
    Mandat: false
  },
  {
    EprvId: 2026042,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-11-15",
    EprvDateFin: "2025-11-16",
    StructureNom: "REIMS",
    EprvNom: "2X18M DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026043,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-15",
    EprvDateFin: "2025-11-16",
    StructureNom: "BAR SUR SEINE",
    EprvNom: "LA JEAN VILAR",
    EprvLieu: "BAR SUR SEINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026044,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-15",
    EprvDateFin: "2025-11-16",
    StructureNom: "REIMS",
    EprvNom: "2X18M DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026045,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-15",
    EprvDateFin: "2025-11-16",
    StructureNom: "HAGONDANGE",
    EprvNom: "TIR 18M HAGONDANGE ",
    EprvLieu: "HAGONDANGE ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026046,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-15",
    EprvDateFin: "2025-11-16",
    StructureNom: "NANCY",
    EprvNom: "2*18 M NANCY",
    EprvLieu: "NANCY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026047,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-15",
    EprvDateFin: "2025-11-15",
    StructureNom: "NANCY",
    EprvNom: "TIR FÉMININ ET MIXTE",
    EprvLieu: "NANCY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026048,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-11-16",
    EprvDateFin: "2025-11-16",
    StructureNom: "VITTEL",
    EprvNom: "TIR A 18M SANS DUELS",
    EprvLieu: "CONTREXEVILLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026049,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-16",
    EprvDateFin: "2025-11-16",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CHALLENGE D'AUTOMNE ",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026050,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-16",
    EprvDateFin: "2025-11-16",
    StructureNom: "VITTEL",
    EprvNom: "TIR A 18M SANS DUELS",
    EprvLieu: "CONTREXEVILLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026051,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2025-11-22",
    EprvDateFin: "2025-11-22",
    StructureNom: "BAR LE DUC",
    EprvNom: "AMICAL JEUNES",
    EprvLieu: "BAR LE DUC",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2026052,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-11-22",
    EprvDateFin: "2025-11-22",
    StructureNom: "TROYES",
    EprvNom: "DÉBUTANTS",
    EprvLieu: "TROYES",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026053,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-22",
    EprvDateFin: "2025-11-23",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "SALLE 18 M",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026054,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-22",
    EprvDateFin: "2025-11-23",
    StructureNom: "SARREGUEMINES",
    EprvNom: "CONCOURS SALLE SARREGUEMINES ",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026055,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-11-23",
    EprvDateFin: "2025-11-23",
    StructureNom: "TROYES",
    EprvNom: "TIR SALLE",
    EprvLieu: "TROYES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026056,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-23",
    EprvDateFin: "2025-11-23",
    StructureNom: "TROYES",
    EprvNom: "TIR SALLE",
    EprvLieu: "TROYES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026057,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-23",
    EprvDateFin: "2025-11-23",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "COMPÉTITION DES TROIS FRONTIÈRES",
    EprvLieu: "MULHOUSE - CENTRE SPORTIF RÉGIONAL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026058,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-23",
    EprvDateFin: "2025-11-23",
    StructureNom: "BAR LE DUC",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "BAR LE DUC",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026059,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-11-29",
    EprvDateFin: "2025-11-30",
    StructureNom: "FISMES",
    EprvNom: "TIR A 18M SALLE",
    EprvLieu: "GYMNASE THIBAUT DE CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026060,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-29",
    EprvDateFin: "2025-11-30",
    StructureNom: "FISMES",
    EprvNom: "TIR A 18M SALLE",
    EprvLieu: "GYMNASE THIBAUT DE CHAMPAGNE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026061,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-29",
    EprvDateFin: "2025-11-30",
    StructureNom: "LUNEVILLE",
    EprvNom: "CONCOURS SELECTIF INDIVIDUEL",
    EprvLieu: "LUNÉVILLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026062,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-29",
    EprvDateFin: "2025-11-30",
    StructureNom: "AUXON",
    EprvNom: "TIR SALLE 18M",
    EprvLieu: "ERVY LE CHATEL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026063,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-29",
    EprvDateFin: "2025-11-29",
    StructureNom: "HAYANGE",
    EprvNom: "2X25M",
    EprvLieu: "HAYANGE",
    InfoSupVal: "2X25M",
    Mandat: true
  },
  {
    EprvId: 2026064,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-30",
    EprvDateFin: "2025-11-30",
    StructureNom: "HAYANGE",
    EprvNom: "COMPETITION 18M",
    EprvLieu: "HAYANGE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026065,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-11-30",
    EprvDateFin: "2025-11-30",
    StructureNom: "BRUNSTATT",
    EprvNom: "TIR EN SALLE 18 M",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026066,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2025-12-05",
    EprvDateFin: "2025-12-06",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CHALLENGE DU TELETHON 2026",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026068,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-07",
    StructureNom: "MAIZIERES GDE PAROISSE",
    EprvNom: "TIR SALLE 18M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026069,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-06",
    StructureNom: "SELESTAT",
    EprvNom: "SPECIAL JEUNES ET ADULTES DEBUTANTS",
    EprvLieu: "SELESTAT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026070,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-07",
    StructureNom: "BETTANCOURT LA FERREE",
    EprvNom: "CONCOURS SALLE 2X18M SELECTIF",
    EprvLieu: "BETTANCOURT-LA-FERRÉE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026071,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-07",
    StructureNom: "MAIZIERES GDE PAROISSE",
    EprvNom: "TIR SALLE 18M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026072,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-07",
    StructureNom: "GUEUX",
    EprvNom: "TIR EN SALLE GUEUX",
    EprvLieu: "COMPLEXE SPORTIF DE GUEUX",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026999,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-06",
    StructureNom: "LES ARCHERS CHALONNAIS",
    EprvNom: "COMPÉTITION JEUNES",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2026999,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-06",
    StructureNom: "LES ARCHERS CHALONNAIS",
    EprvNom: "COMPÉTITION JEUNES",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2026073,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-07",
    StructureNom: "CONFLANS EN JARNISY",
    EprvNom: "CONCOURS CONFLANS EN JARNISY",
    EprvLieu: "CONFLANS EN JARNISY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026074,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-06",
    EprvDateFin: "2025-12-06",
    StructureNom: "CONFLANS EN JARNISY",
    EprvNom: "CONCOURS CONFLANS EN JARNISY",
    EprvLieu: "CONFLANS EN JARNISY",
    InfoSupVal: "2X25M",
    Mandat: true
  },
  {
    EprvId: 2026075,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-07",
    EprvDateFin: "2025-12-07",
    StructureNom: "SELESTAT",
    EprvNom: "CONCOURS SELECTIF",
    EprvLieu: "SELESTAT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026077,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-12-08",
    EprvDateFin: "2025-12-08",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026078,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-08",
    EprvDateFin: "2025-12-08",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026079,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-13",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "CHALLENGE US",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Challenge par équipe",
    Mandat: true
  },
  {
    EprvId: 2026080,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-14",
    StructureNom: "EPERNAY",
    EprvNom: "CONCOURS SELECTIF SALLE ",
    EprvLieu: "EPERNAY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026081,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-14",
    StructureNom: "ST NICOLAS DE PORT",
    EprvNom: "CONCOURS ANNUEL 2025",
    EprvLieu: "ST NICOLAS DE PORT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026082,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-14",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TIR SALLE MONTIGNY",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026083,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-14",
    StructureNom: "EPERNAY",
    EprvNom: "CONCOURS SELECTIF SALLE ",
    EprvLieu: "EPERNAY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026084,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-14",
    StructureNom: "VAUCHONVILLIERS",
    EprvNom: "CONCOURS SALLE - 2X18M",
    EprvLieu: "VENDEUVRE SUR BARSE 10140",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026085,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-14",
    StructureNom: "ST NICOLAS DE PORT",
    EprvNom: "CONCOURS ANNUEL 2025",
    EprvLieu: "ST NICOLAS DE PORT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026086,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-13",
    EprvDateFin: "2025-12-14",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TIR SALLE MONTIGNY",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026087,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-14",
    EprvDateFin: "2025-12-14",
    StructureNom: "COMMERCY",
    EprvNom: "CONCOURS DÉPARTEMENTAL MEUSE, 25 ANS DU CLUB",
    EprvLieu: "COMMERCY",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026088,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-14",
    EprvDateFin: "2025-12-14",
    StructureNom: "VANDOEUVRE",
    EprvNom: "41ÈME CHALLENGE DE VANDOEUVRE",
    EprvLieu: "VANDOEUVRE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026089,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-14",
    EprvDateFin: "2025-12-14",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "TIR EN SALLE 18 M",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026090,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-12-19",
    EprvDateFin: "2025-12-19",
    StructureNom: "TOUL",
    EprvNom: "TIR AU SAUCISSON",
    EprvLieu: "TOUL",
    InfoSupVal: "Autre",
    Mandat: false
  },
  {
    EprvId: 2026091,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2025-12-20",
    EprvDateFin: "2025-12-20",
    StructureNom: "OBERNAI",
    EprvNom: "TROPHÉE DES LUTINS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026092,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2025-12-20",
    EprvDateFin: "2025-12-21",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS DE NOEL - 3 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026093,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2025-12-20",
    EprvDateFin: "2025-12-21",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS DE NOEL - 3 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026094,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-03",
    EprvDateFin: "2026-01-03",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "CD57 JEUNE",
    EprvLieu: "ARS SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026095,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-04",
    EprvDateFin: "2026-01-04",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "CONCOURS SALLE 2X18M",
    EprvLieu: "ARS SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026096,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-10",
    StructureNom: "REIMS",
    EprvNom: "CONCOURS JEUNES DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2026097,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-10",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "SALLE LOISIR À 18M",
    EprvLieu: "HAUCOURT-MOULAINE ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026098,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-10",
    StructureNom: "BRUMATH",
    EprvNom: "SPECIAL JEUNES ET ADULTES DEBUTANTS",
    EprvLieu: "BRUMATH",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026099,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-11",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR SALLE 2026",
    EprvLieu: "CHAOURCE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026100,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-11",
    StructureNom: "ECLARON",
    EprvNom: "CD 52 CONCOURS SALLE ECLARON",
    EprvLieu: "SAINT DIZIER",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026101,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-11",
    StructureNom: "STE MENEHOULD",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "SAINTE MENEHOULD",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026102,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-10",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CHAMPIONAT DEPARTEMENTAL JEUNES ",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026103,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-10",
    EprvDateFin: "2026-01-10",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "25 M EN SALLE ",
    EprvLieu: "HAUCOURT -MOULAINE ST CHARLES",
    InfoSupVal: "2X25M",
    Mandat: true
  },
  {
    EprvId: 2026104,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-01-11",
    EprvDateFin: "2026-01-11",
    StructureNom: "BRUNSTATT",
    EprvNom: "CONCOURS SELECTIF SALLE ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026105,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-11",
    EprvDateFin: "2026-01-11",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS ANNUEL 2026",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026106,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-11",
    EprvDateFin: "2026-01-11",
    StructureNom: "BRUNSTATT",
    EprvNom: "CONCOURS SELECTIF SALLE ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026107,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-11",
    EprvDateFin: "2026-01-11",
    StructureNom: "BRUMATH",
    EprvNom: "TIR EN SALLE 2X18M",
    EprvLieu: "BRUMATH",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026108,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-11",
    EprvDateFin: "2026-01-11",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "18 M EN SALLE",
    EprvLieu: "HAUCOURT-MOULAINE ST CHARLES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026109,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-01-17",
    EprvDateFin: "2026-01-17",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI DÉBUTANTS JEUNES ET ADULTES",
    EprvLieu: "COLMAR",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026110,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-01-17",
    EprvDateFin: "2026-01-18",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES SALLE 2026",
    EprvLieu: "SUIPPES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026111,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-17",
    EprvDateFin: "2026-01-18",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES SALLE 2026",
    EprvLieu: "SUIPPES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026112,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-17",
    EprvDateFin: "2026-01-18",
    StructureNom: "EINVILLE",
    EprvNom: "CONCOURS SALLE 18M",
    EprvLieu: "EINVILLE",
    InfoSupVal: "4X18M",
    Mandat: true
  },
  {
    EprvId: 2026113,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-17",
    EprvDateFin: "2026-01-18",
    StructureNom: "NEUFCHATEAU",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "NEUFCHATEAU",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026114,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-18",
    EprvDateFin: "2026-01-18",
    StructureNom: "VAGNEY",
    EprvNom: "TIR EN SALLE DE VAGNEY ",
    EprvLieu: "VAGNEY ",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026998,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-01-18",
    EprvDateFin: "2026-01-18",
    StructureNom: "COLMAR",
    EprvNom: "8h en duo",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026115,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-01-19",
    EprvDateFin: "2026-01-19",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026116,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-19",
    EprvDateFin: "2026-01-19",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026117,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-01-24",
    EprvDateFin: "2026-01-25",
    StructureNom: "SUIPPES",
    EprvNom: "CD51 SALLE",
    EprvLieu: "SUIPPES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026118,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-24",
    EprvDateFin: "2026-01-25",
    StructureNom: "SUIPPES",
    EprvNom: "CD51 SALLE",
    EprvLieu: "SUIPPES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026119,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-24",
    EprvDateFin: "2026-01-25",
    StructureNom: "BAR SUR SEINE",
    EprvNom: "CD 10 - LA JEAN VILAR",
    EprvLieu: "BAR SUR SEINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026120,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-24",
    EprvDateFin: "2026-01-25",
    StructureNom: "TOUL",
    EprvNom: "CONCOURS SALLE TOUL CD ADULTES",
    EprvLieu: "TOUL",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026121,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-24",
    EprvDateFin: "2026-01-25",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CHAMPIONNAT DÉPARTEMENTAL 08",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026122,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-24",
    EprvDateFin: "2026-01-25",
    StructureNom: "HETTANGE GRANDE",
    EprvNom: "CD 57 ADULTES",
    EprvLieu: "HETTANGE GRANDE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026123,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-25",
    EprvDateFin: "2026-01-25",
    StructureNom: "STE CROIX ARC CLUB",
    EprvNom: "2 X 18 M SÉLÉCTIF",
    EprvLieu: "SAINTE CROIX EN PLAINE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026124,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-25",
    EprvDateFin: "2026-01-25",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CD67 - TIR INDIVIDUEL 2X18M",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026125,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-01-31",
    EprvDateFin: "2026-01-31",
    StructureNom: "HEILLECOURT",
    EprvNom: "CHAMPIONNAT DÉPARTEMENTAL PARA-TIR À L'ARC",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026126,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-01-31",
    EprvDateFin: "2026-01-31",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026127,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-31",
    EprvDateFin: "2026-02-01",
    StructureNom: "THAON LES VOSGES",
    EprvNom: "CONCOURS SALLE ",
    EprvLieu: "THAON LES VOSGES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026128,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-01-31",
    EprvDateFin: "2026-01-31",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026997,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-02-01",
    EprvDateFin: "2026-02-01",
    StructureNom: "LA FLECHE D'AFFRIQUE LUDREENNE",
    EprvNom: "CONCOURS SALLE SELECTIF FRANCE",
    EprvLieu: "LUDRES",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026129,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-02-01",
    EprvDateFin: "2026-02-01",
    StructureNom: "VOLGELSHEIM",
    EprvNom: "CD68 JEUNES ET ADULTES",
    EprvLieu: "VOLGELSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026130,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-02-07",
    EprvDateFin: "2026-02-07",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "CHAMPIONNAT RÉGIONAL SALLE JEUNES",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026131,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-02-08",
    EprvDateFin: "2026-02-08",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "CHAMPIONNAT RÉGIONAL SALLE ADULTES",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026132,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-02-14",
    EprvDateFin: "2026-02-14",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "CONCOURS SPECIAL JEUNES",
    EprvLieu: "AŸ CHAMPAGNE",
    InfoSupVal: "Jeunes débutants",
    Mandat: true
  },
  {
    EprvId: 2026133,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-02-15",
    EprvDateFin: "2026-02-15",
    StructureNom: "PONT A MOUSSON",
    EprvNom: "TIR À 18M",
    EprvLieu: "PONT À MOUSSON",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026134,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-02-15",
    EprvDateFin: "2026-02-15",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "TIR INDIVIDUEL + FINALES PAR EQUIPES",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026135,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-02-15",
    EprvDateFin: "2026-02-15",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "TIR INDIVIDUEL + FINALES PAR EQUIPES",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026136,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-02-15",
    EprvDateFin: "2026-02-15",
    StructureNom: "PONT A MOUSSON",
    EprvNom: "TIR À 18M",
    EprvLieu: "PONT À MOUSSON",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026137,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-02-21",
    EprvDateFin: "2026-02-21",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "CHAMPIONNAT REGIONAL PARA TIR A L ARC",
    EprvLieu: "COLOMBEY LES BELLES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026138,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-02-22",
    EprvDateFin: "2026-02-22",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "CONCOURS AMICAL",
    EprvLieu: "COLOMBEY LES BELLES",
    InfoSupVal: "Tir à l Arc au Féminin",
    Mandat: true
  },
  {
    EprvId: 2026139,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2026-03-14",
    EprvDateFin: "2026-03-14",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "CONCOURS JEUNES",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2026140,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-03-14",
    EprvDateFin: "2026-03-14",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "RENCONTRE DÉBUTANTS JEUNES ET ADULTES",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026141,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-03-15",
    EprvDateFin: "2026-03-15",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "TROPHÉE DES MIXTES DEPARTEMENTAL",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "Trophée des mixtes",
    Mandat: true
  },
  {
    EprvId: 2026142,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2026-03-21",
    EprvDateFin: "2026-03-21",
    StructureNom: "TOUL",
    EprvNom: "CONCOURS JEUNES ET U11",
    EprvLieu: "TOUL",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2026143,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-03-21",
    EprvDateFin: "2026-03-21",
    StructureNom: "OBERNAI",
    EprvNom: "TROPHEE DU PRINTEMPS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026995,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-03-22",
    EprvDateFin: "2026-03-22",
    StructureNom: "GORZE",
    EprvNom: "TIR NATURE CHAMPIONNAT DÉPARTEMENTAL 57 à GORZE",
    EprvLieu: "GORZE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026144,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-03-28",
    EprvDateFin: "2026-03-28",
    StructureNom: "TOUL",
    EprvNom: "CONCOURS INTERNE",
    EprvLieu: "TOUL",
    InfoSupVal: "Jeunes débutants",
    Mandat: false
  },
  {
    EprvId: 2026996,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-03-28",
    EprvDateFin: "2026-03-28",
    StructureNom: "LONGUEVAL",
    EprvNom: "TIR CAMPAGNE",
    EprvLieu: "LONGUEVAL (02)",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026145,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-03-29",
    EprvDateFin: "2026-03-29",
    StructureNom: "CHAOURCE",
    EprvNom: "CONCOURS 3D CHAOURCE",
    EprvLieu: "LES LOGES MARGUERONS",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026148,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2026-04-04",
    EprvDateFin: "2026-04-04",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "INTERCLUB DEBUTANT",
    EprvLieu: "ARS SUR MOSELLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2026149,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-04-05",
    EprvDateFin: "2026-04-05",
    StructureNom: "NANCY",
    EprvNom: "CAMPAGNE NANCY BRABOIS",
    EprvLieu: "NANCY",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026150,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-04-06",
    EprvDateFin: "2026-09-06",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "TIR  BEURSAULT",
    EprvLieu: "MONT L'ETROIT",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026151,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-04-11",
    EprvDateFin: "2026-08-30",
    StructureNom: "ECLARON",
    EprvNom: "BEURSAULT ECLARON 2026",
    EprvLieu: "ECLARON",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026152,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-04-11",
    EprvDateFin: "2026-08-30",
    StructureNom: "ECLARON",
    EprvNom: "CR BEURSAULT GRAND EST",
    EprvLieu: "JEUX D'ARC DE LA REGION",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026153,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2026-04-11",
    EprvDateFin: "2026-04-11",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "FINALE CHALLENGE BERNARD LOUIS",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2026154,
    ChampionnatId: 14,
    ChampionnatLibelle: "Run archery",
    EprvDateDebut: "2026-04-12",
    EprvDateFin: "2026-04-12",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "RUN ARCHERY",
    EprvLieu: "CHALONS EN CHAMPAGNE",
    InfoSupVal: "Run Archery",
    Mandat: true
  },
  {
    EprvId: 2026155,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-04-12",
    EprvDateFin: "2026-04-12",
    StructureNom: "REIMS",
    EprvNom: "3D DE REIMS  DU 12 AVRIL 2026",
    EprvLieu: "FORT DE FRESNE LES REIMS",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026156,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-04-12",
    EprvDateFin: "2026-04-12",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "TIR PAR EQUIPE DE PRINTEMPS",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "2X18M",
    Mandat: true
  },
  {
    EprvId: 2026157,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-04-12",
    EprvDateFin: "2026-04-12",
    StructureNom: "FROUARD",
    EprvNom: "PARCOURS AMICAL SUR 20 CIBLES",
    EprvLieu: "FROUARD",
    InfoSupVal: "Autre",
    Mandat: true
  },
  {
    EprvId: 2026161,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-04-18",
    EprvDateFin: "2026-08-23",
    StructureNom: "FISMES",
    EprvNom: "BEURSAULT  FISMES",
    EprvLieu: "FISMES",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026158,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-04-19",
    EprvDateFin: "2026-04-19",
    StructureNom: "VOLGELSHEIM",
    EprvNom: "1ÈRE MANCHE DRE",
    EprvLieu: "VOLGELSHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026159,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-04-19",
    EprvDateFin: "2026-04-19",
    StructureNom: "VOLGELSHEIM",
    EprvNom: "1ÈRE MANCHE DRE",
    EprvLieu: "VOLGELSHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026160,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-04-19",
    EprvDateFin: "2026-04-19",
    StructureNom: "EPINAL 1ER",
    EprvNom: "TIR NATURE EPINAL CD 88 ( 2 DÉPARTS)",
    EprvLieu: "EPINAL",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026163,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-04-25",
    EprvDateFin: "2026-07-26",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "BEURSAULT",
    EprvLieu: "BRIENNE LE CHATEAU",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026164,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-04-25",
    EprvDateFin: "2026-06-28",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "CONCOURS BEURSAULT",
    EprvLieu: "CHÂLONS EN CHAMPAGNE",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026165,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-04-25",
    EprvDateFin: "2026-04-26",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "TIR LOISIRS DECOUVERTE BLASONS",
    EprvLieu: "LA VEUVE",
    InfoSupVal: "Jeux du tir à l'arc",
    Mandat: true
  },
  {
    EprvId: 2026166,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-04-25",
    EprvDateFin: "2026-04-26",
    StructureNom: "GUEUX",
    EprvNom: "TIR EN CAMPAGNE FORT DE MONTBRÉ - CD 51",
    EprvLieu: "FORT DE MONTBRÉ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026168,
    ChampionnatId: 2,
    ChampionnatLibelle: "Jeunes",
    EprvDateDebut: "2026-04-25",
    EprvDateFin: "2026-04-25",
    StructureNom: "LUDRES",
    EprvNom: "CONCOURS SPECIAL JEUNES",
    EprvLieu: "LUDRES",
    InfoSupVal: "RENCONTRE JEUNES",
    Mandat: true
  },
  {
    EprvId: 2026169,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-04-26",
    EprvDateFin: "2026-08-23",
    StructureNom: "FISMES",
    EprvNom: "TIR BEURSAULT CRTA",
    EprvLieu: "FISMES",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026170,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-04-26",
    EprvDateFin: "2026-04-26",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "CONCOURS 3D ",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026173,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-04-26",
    EprvDateFin: "2026-04-26",
    StructureNom: "MAIZIERES GDE PAROISSE",
    EprvNom: "CONCOURS 3D MARIGNY LE CHATEL - CD10",
    EprvLieu: "MARIGNY LE CHATEL",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026174,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-05-01",
    EprvDateFin: "2026-05-01",
    StructureNom: "PONT ST VINCENT",
    EprvNom: "TIR NATURE 1ER MAI - CD54 ET CR",
    EprvLieu: "PONT SAINT VINCENT",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026175,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-01",
    EprvDateFin: "2026-05-01",
    StructureNom: "BRUNSTATT",
    EprvNom: "TIR DU MUGUET ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026176,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-05-01",
    EprvDateFin: "2026-05-01",
    StructureNom: "BRUNSTATT",
    EprvNom: "TIR DU MUGUET ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026177,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-05-01",
    EprvDateFin: "2026-05-01",
    StructureNom: "SARREGUEMINES",
    EprvNom: "TIR CAMPAGNE DU BUCHHOLZ CD57",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026178,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-02",
    EprvDateFin: "2026-05-03",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE DE PRINTEMPS 2026",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026179,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-05-02",
    EprvDateFin: "2026-05-03",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE DE PRINTEMPS 2026",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026180,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-05-02",
    EprvDateFin: "2026-05-02",
    StructureNom: "SARREGUEMINES",
    EprvNom: "TIR CAMPAGNE DU BUCHHOLZ",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026181,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-03",
    EprvDateFin: "2026-05-03",
    StructureNom: "RETHEL",
    EprvNom: "TIR EXTÉRIEUR - CD 08",
    EprvLieu: "RETHEL",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026182,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-05-03",
    EprvDateFin: "2026-05-03",
    StructureNom: "THANN",
    EprvNom: "CAMPAGNE DU RANGEN - CD 68",
    EprvLieu: "THANN",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026183,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-05-09",
    EprvDateFin: "2026-05-10",
    StructureNom: "VERTUS BLANCS COTEAUX",
    EprvNom: "CIRCUIT DES 5 NATIONS - VERTUS",
    EprvLieu: "VERTUS  BLANCS-COTEAUX",
    InfoSupVal: "(12 CONNUES + 12 INCONNUES) X2",
    Mandat: true
  },
  {
    EprvId: 2026184,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-05-09",
    EprvDateFin: "2026-05-10",
    StructureNom: "SARREBOURG",
    EprvNom: "TIR 3D À LETTENBACH - 3 DÉPARTS",
    EprvLieu: "ABRESCHVILLER (LETTENBACH)",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026185,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-09",
    EprvDateFin: "2026-05-10",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "TAE - DOMBASLE",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026186,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-05-09",
    EprvDateFin: "2026-05-10",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "TAE - DOMBASLE",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026187,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-09",
    EprvDateFin: "2026-05-09",
    StructureNom: "MOURMELON LE GRAND",
    EprvNom: "LIGUE NORD EST FCD",
    EprvLieu: "MOURMELON LE GRAND",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2026188,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-10",
    EprvDateFin: "2026-05-10",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "TAEI ET TAEN - CD51 TAEI",
    EprvLieu: "CHALONS EN CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026189,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-05-10",
    EprvDateFin: "2026-05-10",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "TAEI ET TAEN - CD51 TAEI",
    EprvLieu: "CHALONS EN CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026190,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-05-14",
    EprvDateFin: "2026-05-14",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "TIR CAMPAGNE 2026 CHATEAU DE CONS LA GRANDVILLE",
    EprvLieu: "CONS LA GRANDVILLE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026193,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-05-17",
    EprvDateFin: "2026-05-17",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "CONCOURS CAMPAGNE ",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026194,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-17",
    EprvDateFin: "2026-05-17",
    StructureNom: "CHAUMONT",
    EprvNom: "TA EXTERIEUR - CD 52",
    EprvLieu: "CHAUMONT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026195,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-05-17",
    EprvDateFin: "2026-05-17",
    StructureNom: "CHAUMONT",
    EprvNom: "TA EXTERIEUR - CD 52",
    EprvLieu: "CHAUMONT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026197,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-23",
    EprvDateFin: "2026-05-25",
    StructureNom: "CHAOURCE",
    EprvNom: "TAE",
    EprvLieu: "CHAOURCE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026198,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-23",
    EprvDateFin: "2026-05-24",
    StructureNom: "LUNEVILLE",
    EprvNom: "TAE INTERNATIONAL CD54",
    EprvLieu: "LUNÉVILLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026199,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-05-23",
    EprvDateFin: "2026-05-24",
    StructureNom: "VAGNEY",
    EprvNom: "TIR CAMPAGNE DE VAGNEY - CD 88",
    EprvLieu: "VAGNEY",
    InfoSupVal: "(12 CONNUES + 12 INCONNUES) X2",
    Mandat: true
  },
  {
    EprvId: 2026200,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-05-24",
    EprvDateFin: "2026-05-24",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "TIR 3D - CD57 - ANCY DORNOT",
    EprvLieu: "ANCY DORNOT",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026201,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-30",
    EprvDateFin: "2026-05-31",
    StructureNom: "BETTANCOURT LA FERREE",
    EprvNom: "TAE & 2E MANCHE DR GRAND-EST",
    EprvLieu: "BETTANCOURT-LA-FERRÉE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026202,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-30",
    EprvDateFin: "2026-05-31",
    StructureNom: "BETTANCOURT LA FERREE",
    EprvNom: "TAE & 2E MANCHE DR GRAND-EST",
    EprvLieu: "BETTANCOURT-LA-FERRÉE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026162,
    ChampionnatId: 13,
    ChampionnatLibelle: "Tir Beursault",
    EprvDateDebut: "2026-05-30",
    EprvDateFin: "2026-05-31",
    StructureNom: "EINVILLE",
    EprvNom: "BEURSAULT",
    EprvLieu: "EINVILLE",
    InfoSupVal: "Beursault sélectif",
    Mandat: true
  },
  {
    EprvId: 2026203,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-05-31",
    EprvDateFin: "2026-05-31",
    StructureNom: "EINVILLE",
    EprvNom: "TAE I ET N",
    EprvLieu: "EINVILLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026204,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-06",
    EprvDateFin: "2026-06-07",
    StructureNom: "TROYES",
    EprvNom: "**Annulé**TIR EN EXTERIEUR A TROYES**Annulé**",
    EprvLieu: "TROYES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2026205,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-06",
    EprvDateFin: "2026-06-07",
    StructureNom: "TROYES",
    EprvNom: "**Annulé**TIR EN EXTERIEUR A TROYES**Annulé**",
    EprvLieu: "TROYES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2026206,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-06",
    EprvDateFin: "2026-06-07",
    StructureNom: "THAON LES VOSGES",
    EprvNom: "TAE N ET I THAON LES VOSGES",
    EprvLieu: "THAON LES VOSGES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026207,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-06",
    EprvDateFin: "2026-06-07",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "TAE DU BOLLWERK",
    EprvLieu: "RIEDISHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026208,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-06",
    EprvDateFin: "2026-06-07",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "TAE DU BOLLWERK",
    EprvLieu: "RIEDISHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026209,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2026-06-06",
    EprvDateFin: "2026-06-06",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI U11",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026210,
    ChampionnatId: 5,
    ChampionnatLibelle: "Rencontres Clubs Loisirs",
    EprvDateDebut: "2026-06-06",
    EprvDateFin: "2026-06-06",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI DÉBUTANTS JEUNES ET ADULTES",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026211,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-07",
    EprvDateFin: "2026-06-07",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES TAE 2026",
    EprvLieu: "SOMME-SUIPPE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026212,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-07",
    EprvDateFin: "2026-06-07",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES TAE 2026",
    EprvLieu: "SOMME-SUIPPE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026214,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TAE VILLE SOUS LA FERTE - CD10",
    EprvLieu: "VILLE SOUS LA FERTE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026215,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TAE VILLE SOUS LA FERTE - CD10",
    EprvLieu: "VILLE SOUS LA FERTE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026216,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "DIEUZE",
    EprvNom: "TAEI CD57",
    EprvLieu: "DIEUZE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026217,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "DIEUZE",
    EprvNom: "TAEN ",
    EprvLieu: "DIEUZE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026218,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "VITTEL",
    EprvNom: "TAEI TAEN VITTEL",
    EprvLieu: "VITTEL",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026219,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "BRUNSTATT",
    EprvNom: "TAEN+TAEI CD 68",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026220,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "BRUNSTATT",
    EprvNom: "TAEN+TAEI CD 68",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026221,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-14",
    StructureNom: "VITTEL",
    EprvNom: "TAEI TAEN VITTEL",
    EprvLieu: "VITTEL",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026222,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-13",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS CD54 TAE N+PARA  ",
    EprvLieu: "ST NICOLAS DE PORT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026223,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-06-13",
    EprvDateFin: "2026-06-13",
    StructureNom: "FROUARD",
    EprvNom: "TIR CAMPAGNE POUR LES DÉBUTANTS ET LES JEUNES",
    EprvLieu: "FROUARD",
    InfoSupVal: "Débutants",
    Mandat: true
  },
  {
    EprvId: 2026224,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-14",
    EprvDateFin: "2026-06-14",
    StructureNom: "REIMS",
    EprvNom: "TAE DE REIMS - CD51 TAEN",
    EprvLieu: "BETHENY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026225,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-14",
    EprvDateFin: "2026-06-14",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CHAMPIONNAT DEPARTEMENTAL PAR EQUIPE",
    EprvLieu: "SAINT NICOLAS DE PORT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026227,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-06-14",
    EprvDateFin: "2026-06-14",
    StructureNom: "GORZE",
    EprvNom: "3D GORZE JUIN 2 DEPARTS",
    EprvLieu: "GORZE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026228,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-06-14",
    EprvDateFin: "2026-06-14",
    StructureNom: "TOUL",
    EprvNom: "CAMPAGNE - TOUL",
    EprvLieu: "PAGNEY DERRIERE BARINE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026229,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-20",
    EprvDateFin: "2026-06-21",
    StructureNom: "ST DIE",
    EprvNom: "CHALLENGE DU ROY DOM",
    EprvLieu: "ST DIE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026230,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-20",
    EprvDateFin: "2026-06-21",
    StructureNom: "ST DIE",
    EprvNom: "CHALLENGE DU ROY DOM",
    EprvLieu: "ST DIE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026231,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-06-20",
    EprvDateFin: "2026-06-21",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR CAMPAGNE - CD10",
    EprvLieu: "LAFERTE SUR AUBE",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026232,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-06-20",
    EprvDateFin: "2026-06-20",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "TAE JEUNES",
    EprvLieu: "MAREUIL SUR AY",
    InfoSupVal: "Autre",
    Mandat: true
  },
  {
    EprvId: 2026233,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-20",
    EprvDateFin: "2026-06-20",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TAE BRIENNE LE CHATEAU",
    EprvLieu: "BRIENNE LE CHATEAU",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026234,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-06-20",
    EprvDateFin: "2026-06-20",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TAE BRIENNE LE CHATEAU",
    EprvLieu: "BRIENNE LE CHATEAU",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026235,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-21",
    EprvDateFin: "2026-06-21",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TAE I+N / DRE3",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026236,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-21",
    EprvDateFin: "2026-06-21",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TAE I+N / DRE3",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026237,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs",
    EprvDateDebut: "2026-06-27",
    EprvDateFin: "2026-06-27",
    StructureNom: "REIMS",
    EprvNom: "AMICAL JEUNES ET DÉBUTANTS REMOIS",
    EprvLieu: "BETHENY",
    InfoSupVal: "Débutants",
    Mandat: false
  },
  {
    EprvId: 2026238,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-06-27",
    EprvDateFin: "2026-06-27",
    StructureNom: "CD BAS RHIN (67)",
    EprvNom: "**Annulé** HAUT KOENIGSBOURG CAMPAGNE CD67 **Annulé**",
    EprvLieu: "ORSCHWILLER",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026239,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-06-28",
    EprvDateFin: "2026-06-28",
    StructureNom: "SAINT DIZIER",
    EprvNom: "TIR 3D DE SAINT-DIZIER CD52",
    EprvLieu: "SOMMELONNE",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026240,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-28",
    EprvDateFin: "2026-06-28",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "**Annulé** CHAMPIONNAT RÉGIONAL TAEN ET CD67 **Annulé**",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026241,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-28",
    EprvDateFin: "2026-06-28",
    StructureNom: "HAYANGE",
    EprvNom: "**Annulé** TAEN CD57 + TAEI **Annulé**",
    EprvLieu: "HAYANGE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026242,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-06-28",
    EprvDateFin: "2026-06-28",
    StructureNom: "VAGNEY",
    EprvNom: "**Annulé** TAE N-TAE I DE VAGNEY **Annulé**",
    EprvLieu: "VAGNEY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026243,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-06-28",
    EprvDateFin: "2026-06-28",
    StructureNom: "CR DU GRAND EST",
    EprvNom: "**Annulé** HAUT KOENIGSBOURG CR CAMPAGNE **Annulé**",
    EprvLieu: "ORSCHWILLER",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026244,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-07-05",
    EprvDateFin: "2026-07-05",
    StructureNom: "VERDUN",
    EprvNom: "TIR 3D - CR - 110 ANS DE LA BATAILLE DE VERDUN",
    EprvLieu: "VERDUN",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026245,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-07-05",
    EprvDateFin: "2026-07-05",
    StructureNom: "VERTUS BLANCS COTEAUX",
    EprvNom: "TIR EN CAMPAGNE - VERTUS",
    EprvLieu: "VERTUS  BLANCS-COTEAUX",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026246,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-07-05",
    EprvDateFin: "2026-07-05",
    StructureNom: "MARLY POURNOY",
    EprvNom: "CR TAE I - MARLY",
    EprvLieu: "MARLY POURNOY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026247,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-07-11",
    EprvDateFin: "2026-07-12",
    StructureNom: "GUEUX",
    EprvNom: "TIR 3D FORT DE MONTBRÉ - CD51",
    EprvLieu: "FORT DE MONTBRÉ",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026248,
    ChampionnatId: 12,
    ChampionnatLibelle: "Tir à l'Arc Extérieur",
    EprvDateDebut: "2026-07-12",
    EprvDateFin: "2026-07-12",
    StructureNom: "ARCIS SUR AUBE",
    EprvNom: "TAE",
    EprvLieu: "ARCIS SUR AUBE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026249,
    ChampionnatId: 11,
    ChampionnatLibelle: "Para-tir à l'arc en extérieur",
    EprvDateDebut: "2026-07-12",
    EprvDateFin: "2026-07-12",
    StructureNom: "ARCIS SUR AUBE",
    EprvNom: "TAE",
    EprvLieu: "ARCIS SUR AUBE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2026196,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-07-19",
    EprvDateFin: "2026-07-19",
    StructureNom: "BREUX",
    EprvNom: "CD55 3D",
    EprvLieu: "BREUX",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026250,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-09-05",
    EprvDateFin: "2026-09-06",
    StructureNom: "SARREGUEMINES",
    EprvNom: "TIR CAMPAGNE DU MOULIN DES FAÏENCIERS ",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2026251,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-09-13",
    EprvDateFin: "2026-09-13",
    StructureNom: "GORZE",
    EprvNom: "NATURE GORZE SEPT 2 DEPARTS",
    EprvLieu: "GORZE",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026252,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-09-20",
    EprvDateFin: "2026-09-20",
    StructureNom: "VAGNEY",
    EprvNom: "TIR NATURE DE VAGNEY",
    EprvLieu: "VAGNEY",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026253,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-09-27",
    EprvDateFin: "2026-09-27",
    StructureNom: "REIMS",
    EprvNom: "TIR NATURE DE REIMS",
    EprvLieu: "FORT DE FRESNE LES REIMS",
    InfoSupVal: "21 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2026254,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-09-27",
    EprvDateFin: "2026-09-27",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "3D",
    EprvLieu: "GORCY",
    InfoSupVal: "1 X 24 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2027001,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Confirmé",
    EprvDateDebut: "2026-10-03",
    EprvDateFin: "2026-10-04",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "TIR 12H DES 30ANS DE AMO",
    EprvLieu: "ARS SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027002,
    ChampionnatId: 8,
    ChampionnatLibelle: "Tir en Campagne",
    EprvDateDebut: "2026-10-03",
    EprvDateFin: "2026-10-04",
    StructureNom: "COLMAR",
    EprvNom: "CAMPAGNE DU HAUT KOENIGSBOURG",
    EprvLieu: "ORSCHWILLER",
    InfoSupVal: "12 CONNUES + 12 INCONNUES",
    Mandat: true
  },
  {
    EprvId: 2027003,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-04",
    EprvDateFin: "2026-10-04",
    StructureNom: "VRIGNE AUX BOIS",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "VRIGNE AUX BOIS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027004,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-10",
    EprvDateFin: "2026-10-11",
    StructureNom: "BOULIGNY",
    EprvNom: "CONCOURS SALLE - BOULIGNY",
    EprvLieu: "BOULIGNY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027005,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-10",
    EprvDateFin: "2026-10-11",
    StructureNom: "RETHEL",
    EprvNom: "CONCOURS DE LA RENTRÉE",
    EprvLieu: "RETHEL",
    InfoSupVal: " 11 cibles",
    Mandat: true
  },
  {
    EprvId: 2027006,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-10",
    EprvDateFin: "2026-10-11",
    StructureNom: "SARREBOURG",
    EprvNom: "CONCOURS D'AUTOMNE 3 DÉPARTS",
    EprvLieu: "SARREBOURG",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027007,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-10-11",
    EprvDateFin: "2026-10-11",
    StructureNom: "ILLKIRCH GRAFFENSTADEN",
    EprvNom: "CONCOURS TIR NATURE OCTOBRE ROSE / CD67",
    EprvLieu: "ILLKIRCH-GRAFFENSTADEN",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027008,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-17",
    EprvDateFin: "2026-10-18",
    StructureNom: "CREUTZWALD",
    EprvNom: "SELECTIF FRANCE",
    EprvLieu: "CREUTZWALD",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027009,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-17",
    EprvDateFin: "2026-10-18",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CHALLENGE AUTOMNE ET OCTOBRE ROSE",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027010,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-17",
    EprvDateFin: "2026-10-18",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TIR A 18M",
    EprvLieu: "BRIENNE LE CHATEAU",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027011,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-10-17",
    EprvDateFin: "2026-10-18",
    StructureNom: "ARCHERS BRIENNOIS",
    EprvNom: "TIR A 18M",
    EprvLieu: "BRIENNE LE CHATEAU",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027012,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-17",
    EprvDateFin: "2026-10-18",
    StructureNom: "CHAUMONT",
    EprvNom: "TIR EN SALLE ",
    EprvLieu: "CHAUMONT ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027013,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-10-17",
    EprvDateFin: "2026-10-18",
    StructureNom: "CHAUMONT",
    EprvNom: "TIR EN SALLE ",
    EprvLieu: "CHAUMONT ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027014,
    ChampionnatId: 9,
    ChampionnatLibelle: "Tir Nature",
    EprvDateDebut: "2026-10-18",
    EprvDateFin: "2026-10-18",
    StructureNom: "NEUWILLER LES SAVERNE",
    EprvNom: "CONCOURS NATURE ",
    EprvLieu: "NEUWILLER-LES-SAVERNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027015,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-18",
    EprvDateFin: "2026-10-18",
    StructureNom: "WISSEMBOURG",
    EprvNom: "CHALLENGE D'AUTOMNE",
    EprvLieu: "WISSEMBOURG",
    InfoSupVal: "20 cibles possible sur les 2départs (matin et apres midi)",
    Mandat: true
  },
  {
    EprvId: 2027016,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-18",
    EprvDateFin: "2026-10-18",
    StructureNom: "ST DIE",
    EprvNom: "CONCOURS DE TIR À L'ARC EN SALLE",
    EprvLieu: "SAINT DIÉ DES VOSGES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027017,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-10-18",
    EprvDateFin: "2026-10-18",
    StructureNom: "ST DIE",
    EprvNom: "CONCOURS DE TIR À L'ARC EN SALLE",
    EprvLieu: "SAINT DIÉ DES VOSGES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027018,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-24",
    EprvDateFin: "2026-10-25",
    StructureNom: "ROMILLY SUR SEINE",
    EprvNom: "TIR SALLE 2X18 M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027019,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-10-24",
    EprvDateFin: "2026-10-25",
    StructureNom: "ROMILLY SUR SEINE",
    EprvNom: "TIR SALLE 2X18 M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027020,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-24",
    EprvDateFin: "2026-10-25",
    StructureNom: "FOLSCHVILLER",
    EprvNom: "CONCOURS SELECTIF INDIVIDUEL",
    EprvLieu: "FOLSCHVILLER",
    InfoSupVal: "11 cibles prévues par départ. 3 départs sont prévus.",
    Mandat: true
  },
  {
    EprvId: 2027021,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS NOVEMBRE 3 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "14 cibles - 3 départs",
    Mandat: true
  },
  {
    EprvId: 2027022,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS NOVEMBRE 3 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027023,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "HETTANGE GRANDE",
    EprvNom: "TOURNOI SELECTIF DE LA VILLE DE HETTANGE GRANDE",
    EprvLieu: "HETTANGE GRANDE",
    InfoSupVal: "22 cibles",
    Mandat: true
  },
  {
    EprvId: 2027024,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE D'AUTOMNE",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027025,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "SEICHAMPS",
    EprvNom: "CHALLENGE D'AUTOMNE",
    EprvLieu: "SEICHAMPS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027026,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "CHALONS EN CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027027,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "VENDEUVRE SUR BARSE",
    EprvNom: "TIR EN SALLE LUSIGNY",
    EprvLieu: "LUSIGNY-SUR-BARSE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027028,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "VENDEUVRE SUR BARSE",
    EprvNom: "TIR EN SALLE LUSIGNY",
    EprvLieu: "LUSIGNY-SUR-BARSE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027030,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-10-31",
    EprvDateFin: "2026-11-01",
    StructureNom: "HETTANGE GRANDE",
    EprvNom: "TOURNOI SELECTIF DE LA VILLE DE HETTANGE GRANDE",
    EprvLieu: "HETTANGE GRANDE",
    InfoSupVal: "20 cibles",
    Mandat: true
  },
  {
    EprvId: 2027031,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-07",
    EprvDateFin: "2026-11-08",
    StructureNom: "MONT L'ETROIT",
    EprvNom: "CONCOURS SALLE",
    EprvLieu: "COLOMBEY LES BELLES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027032,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-07",
    EprvDateFin: "2026-11-08",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "CONCOURS  SALLE 2X18",
    EprvLieu: "AY CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027033,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-07",
    EprvDateFin: "2026-11-08",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "CONCOURS  SALLE 2X18",
    EprvLieu: "AY CHAMPAGNE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027034,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-07",
    EprvDateFin: "2026-11-08",
    StructureNom: "CHAOURCE",
    EprvNom: "COURCOURS SALLE",
    EprvLieu: "CHAOURCE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027035,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2026-11-07",
    EprvDateFin: "2026-11-07",
    StructureNom: "SAINT DIZIER",
    EprvNom: "TIR EN SALLE JEUNES & DEBUTANTS",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "Spécial Jeunes et débutants",
    Mandat: true
  },
  {
    EprvId: 2027036,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-08",
    EprvDateFin: "2026-11-08",
    StructureNom: "SAINT DIZIER",
    EprvNom: "TIR SALLE À 18M (2 DÉPARTS)",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "Valides et Paras",
    Mandat: true
  },
  {
    EprvId: 2027037,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-08",
    EprvDateFin: "2026-11-08",
    StructureNom: "SAINT DIZIER",
    EprvNom: "TIR SALLE À 18M (2 DÉPARTS)",
    EprvLieu: "SAINT-DIZIER",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027038,
    ChampionnatId: 6,
    ChampionnatLibelle: "Tir 3D",
    EprvDateDebut: "2026-11-08",
    EprvDateFin: "2026-11-08",
    StructureNom: "EPINAL 1ER",
    EprvNom: "3D SPINAPARC EPINAL - CD88",
    EprvLieu: "EPINAL",
    InfoSupVal: "1*24 cibles",
    Mandat: true
  },
  {
    EprvId: 2027039,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant et confirmé",
    EprvDateDebut: "2026-11-11",
    EprvDateFin: "2026-11-11",
    StructureNom: "NANCY",
    EprvNom: "AMICAL NANCY",
    EprvLieu: "NANCY",
    InfoSupVal: "Amical Jeune et adultes, débutants et confirmés, Valides et non valides, sport adapté accepté",
    Mandat: true
  },
  {
    EprvId: 2027041,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-14",
    EprvDateFin: "2026-11-15",
    StructureNom: "HAGONDANGE",
    EprvNom: "TIR SALLE HAGONDANGE",
    EprvLieu: "HAGONDANGE",
    InfoSupVal: "22 cibles",
    Mandat: true
  },
  {
    EprvId: 2027042,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-14",
    EprvDateFin: "2026-11-15",
    StructureNom: "RETHEL",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "RETHEL",
    InfoSupVal: "11 cibles",
    Mandat: true
  },
  {
    EprvId: 2027043,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-14",
    EprvDateFin: "2026-11-15",
    StructureNom: "BAR SUR SEINE",
    EprvNom: "LA JEAN VILAR",
    EprvLieu: "BAR SUR SEINE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027044,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-14",
    EprvDateFin: "2026-11-15",
    StructureNom: "BAR SUR SEINE",
    EprvNom: "LA JEAN VILAR",
    EprvLieu: "BAR SUR SEINE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027045,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-14",
    EprvDateFin: "2026-11-15",
    StructureNom: "NANCY",
    EprvNom: "2*18M NANCY",
    EprvLieu: "NANCY",
    InfoSupVal: "Départs samedi matin et dimanche après-midi",
    Mandat: true
  },
  {
    EprvId: 2027046,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-14",
    EprvDateFin: "2026-11-14",
    StructureNom: "NANCY",
    EprvNom: "MIXTE NANCY",
    EprvLieu: "NANCY",
    InfoSupVal: "Equipe Mixte ou exclusivement féminine.  Tir sélectif suivi de duels.",
    Mandat: true
  },
  {
    EprvId: 2027047,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-14",
    EprvDateFin: "2026-11-14",
    StructureNom: "NANCY",
    EprvNom: "NANCY PARA TIR À L'ARC",
    EprvLieu: "NANCY",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027048,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-15",
    EprvDateFin: "2026-11-15",
    StructureNom: "STE CROIX ARC CLUB",
    EprvNom: "2X18M ",
    EprvLieu: "SAINTE-CROIX-EN-PLAINE",
    InfoSupVal: "13 cibles max ",
    Mandat: true
  },
  {
    EprvId: 2027049,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-15",
    EprvDateFin: "2026-11-15",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CHALLENGE D'AUTOMNE",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "14 cibles  2 départs",
    Mandat: true
  },
  {
    EprvId: 2027050,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-15",
    EprvDateFin: "2026-11-15",
    StructureNom: "VITTEL",
    EprvNom: "CD 88 SALLE",
    EprvLieu: "VITTEL",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027051,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-15",
    EprvDateFin: "2026-11-15",
    StructureNom: "VITTEL",
    EprvNom: "CD 88 SALLE",
    EprvLieu: "VITTEL",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027052,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-16",
    EprvDateFin: "2026-11-16",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027053,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-16",
    EprvDateFin: "2026-11-16",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027054,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-21",
    EprvDateFin: "2026-11-22",
    StructureNom: "REIMS",
    EprvNom: "2X18M DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "3 départs",
    Mandat: true
  },
  {
    EprvId: 2027055,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-21",
    EprvDateFin: "2026-11-22",
    StructureNom: "REIMS",
    EprvNom: "2X18M DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027056,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-21",
    EprvDateFin: "2026-11-22",
    StructureNom: "DOMBASLE SUR MEURTHE",
    EprvNom: "SALLE 2027",
    EprvLieu: "DOMBASLE SUR MEURTHE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027057,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-21",
    EprvDateFin: "2026-11-22",
    StructureNom: "SARREGUEMINES",
    EprvNom: "CONCOURS SALLE SARREGUEMINES ",
    EprvLieu: "SARREGUEMINES ",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027058,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-21",
    EprvDateFin: "2026-11-21",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "LES TROIS SPOTS",
    EprvLieu: "CENTRE SPORTIF RÉGIONAL D'ALSACE - MULHOUSE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027059,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2026-11-21",
    EprvDateFin: "2026-11-21",
    StructureNom: "BAR LE DUC",
    EprvNom: "AMICAL JEUNES",
    EprvLieu: "BAR LE DUC",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027060,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-22",
    EprvDateFin: "2026-11-22",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "COMPÉTITION DES TROIS FRONTIÈRES - 2026",
    EprvLieu: "CENTRE SPORTIF RÉGIONAL D'ALSACE - MULHOUSE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027061,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-22",
    EprvDateFin: "2026-11-22",
    StructureNom: "BAR LE DUC",
    EprvNom: "CONCOURS INDIVIDUEL - CD55",
    EprvLieu: "BAR LE DUC",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027062,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-29",
    StructureNom: "FISMES",
    EprvNom: "TIR EN SALLE FISMES",
    EprvLieu: "FISMES",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027063,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-29",
    StructureNom: "AUXON",
    EprvNom: "TIR SALLE  18 M",
    EprvLieu: "ERVY LE CHATEL",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027064,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-29",
    StructureNom: "AUXON",
    EprvNom: "TIR SALLE  18 M",
    EprvLieu: "ERVY LE CHATEL",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027065,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-29",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS SALLE  ",
    EprvLieu: "LUNEVILLE",
    InfoSupVal: "Nous organisons un concours salle 2 X18 M sur le commune de Lunéville ",
    Mandat: true
  },
  {
    EprvId: 2027066,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-29",
    StructureNom: "BRUNSTATT",
    EprvNom: "CONCOURS 2 X 18 M",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027067,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-28",
    StructureNom: "HAYANGE",
    EprvNom: "25M SALLE 2026",
    EprvLieu: "HAYANGE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027068,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-28",
    StructureNom: "BRUNSTATT",
    EprvNom: "FITA SALLE",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027069,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-28",
    EprvDateFin: "2026-11-28",
    StructureNom: "BRUNSTATT",
    EprvNom: "FITA SALLE",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027070,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-29",
    EprvDateFin: "2026-11-29",
    StructureNom: "HAYANGE",
    EprvNom: "SALLE 2026 2X18M 2 DEPARTS",
    EprvLieu: "HAYANGE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027071,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-11-29",
    EprvDateFin: "2026-11-29",
    StructureNom: "BRUNSTATT",
    EprvNom: "FITA SALLE ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027072,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-11-29",
    EprvDateFin: "2026-11-29",
    StructureNom: "BRUNSTATT",
    EprvNom: "FITA SALLE ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027073,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-06",
    StructureNom: "BETTANCOURT LA FERREE",
    EprvNom: "CONCOURS SALLE 2X18M SÉLECTIF",
    EprvLieu: "BETTANCOURT-LA-FERRÉE",
    InfoSupVal: "13 cibles prévues",
    Mandat: true
  },
  {
    EprvId: 2027074,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-06",
    StructureNom: "MAIZIERES GDE PAROISSE",
    EprvNom: "TIR SALLE 2 X 18M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "13 cibles",
    Mandat: false
  },
  {
    EprvId: 2027075,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-06",
    StructureNom: "MAIZIERES GDE PAROISSE",
    EprvNom: "TIR SALLE 2 X 18M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027076,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-06",
    StructureNom: "GUEUX",
    EprvNom: "TIR EN SALLE GUEUX",
    EprvLieu: "GUEUX",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027077,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-06",
    StructureNom: "DIEUZE",
    EprvNom: "TIR EN SALLE DIEUZE 2026",
    EprvLieu: "DIEUZE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027078,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-06",
    StructureNom: "CONFLANS EN JARNISY",
    EprvNom: "CONCOURS CONFLANS EN JARNISY",
    EprvLieu: "CONFLANS EN JARNISY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027079,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-05",
    StructureNom: "SELESTAT",
    EprvNom: "SPECIAL JEUNES ET ADULTES DEBUTANTS",
    EprvLieu: "SELESTAT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027080,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-05",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CONCOURS JEUNES TÉLÉTHON",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027081,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-05",
    StructureNom: "COLMAR",
    EprvNom: "TIR EN SALLE 18M",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027082,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-05",
    EprvDateFin: "2026-12-05",
    StructureNom: "CONFLANS EN JARNISY",
    EprvNom: "CONCOURS CONFLANS EN JARNISY",
    EprvLieu: "CONFLANS EN JARNISY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027083,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-06",
    EprvDateFin: "2026-12-06",
    StructureNom: "SELESTAT",
    EprvNom: "CONCOURS SELECTIF",
    EprvLieu: "SELESTAT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027084,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant et confirmé",
    EprvDateDebut: "2026-12-06",
    EprvDateFin: "2026-12-06",
    StructureNom: "COLMAR",
    EprvNom: "LES 8H DE TIR EN DUO",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027085,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-06",
    EprvDateFin: "2026-12-06",
    StructureNom: "SELESTAT",
    EprvNom: "CONCOURS SELECTIF",
    EprvLieu: "SELESTAT",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027086,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-07",
    EprvDateFin: "2026-12-07",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027087,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-07",
    EprvDateFin: "2026-12-07",
    StructureNom: "HEILLECOURT",
    EprvNom: "CONCOURS DES ARCHERS SANS LIMITE",
    EprvLieu: "FLAVIGNY SUR MOSELLE",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027088,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "ST NICOLAS DE PORT",
    EprvNom: "CONCOURS ANNUEL",
    EprvLieu: "SAINT-NICOLAS-DE-PORT",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027089,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "ST NICOLAS DE PORT",
    EprvNom: "CONCOURS ANNUEL",
    EprvLieu: "SAINT-NICOLAS-DE-PORT",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027090,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "EPERNAY",
    EprvNom: "CONCOURS SELECTIF SALLE",
    EprvLieu: "EPERNAY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027091,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "EPERNAY",
    EprvNom: "CONCOURS SELECTIF SALLE",
    EprvLieu: "EPERNAY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027092,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "VAUCHONVILLIERS",
    EprvNom: "TIR EN SALLE 2X 18 M",
    EprvLieu: "VENDEUVRE SUR BARSE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027093,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "VAUCHONVILLIERS",
    EprvNom: "TIR EN SALLE 2X 18 M",
    EprvLieu: "VENDEUVRE SUR BARSE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027094,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TIR SALLE MONTIGNY",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "13 cibles  1 départ le samedi  2 départs le dimanche",
    Mandat: false
  },
  {
    EprvId: 2027095,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-13",
    StructureNom: "MONTIGNY LES METZ A.C.",
    EprvNom: "TIR SALLE MONTIGNY",
    EprvLieu: "MONTIGNY-LÈS-METZ",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027096,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2026-12-12",
    EprvDateFin: "2026-12-12",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "RENCONTRE DEBUTANT ADULTES & JEUNES",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027097,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-13",
    EprvDateFin: "2026-12-13",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "TIR EN SALLE 18M",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027098,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-19",
    EprvDateFin: "2026-12-20",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS DE NOEL - 3 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "14 cibles - 3 départs",
    Mandat: false
  },
  {
    EprvId: 2027099,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2026-12-19",
    EprvDateFin: "2026-12-20",
    StructureNom: "OBERNAI",
    EprvNom: "CONCOURS DE NOEL - 3 DÉPARTS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027100,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-19",
    EprvDateFin: "2026-12-20",
    StructureNom: "MARLY POURNOY",
    EprvNom: "MARLY SALLE",
    EprvLieu: "MARLY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027101,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2026-12-19",
    EprvDateFin: "2026-12-20",
    StructureNom: "NEUFCHATEAU",
    EprvNom: "TIR A 18 M. NEUFCHATEAU",
    EprvLieu: "NEUFCHATEAU",
    InfoSupVal: "",
    Mandat: true
  },
  {
    EprvId: 2027102,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2026-12-19",
    EprvDateFin: "2026-12-19",
    StructureNom: "OBERNAI",
    EprvNom: "TROPHEE DES LUTINS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "18 cibles -double pas de tir",
    Mandat: false
  },
  {
    EprvId: 2027103,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-10",
    StructureNom: "STE MENEHOULD",
    EprvNom: "SALLE SAINTE MENEHOULD",
    EprvLieu: "SAINTE MENEHOULD",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027104,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-10",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR EN SALLE ",
    EprvLieu: "BAR SUR AUBE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027105,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-10",
    StructureNom: "VILLE SOUS LA FERTE",
    EprvNom: "TIR EN SALLE ",
    EprvLieu: "BAR SUR AUBE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027106,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-10",
    StructureNom: "ARS SUR MOSELLE",
    EprvNom: "2X18M",
    EprvLieu: "ARS SUR MOSELLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027107,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-09",
    StructureNom: "REIMS",
    EprvNom: "CONCOURS JEUNES DE REIMS",
    EprvLieu: "REIMS",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027108,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant et confirmé",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-09",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "LOISIRS SALLE SAMEDI 18 M LOISIRS",
    EprvLieu: "HAUCOURT  SAINT CHARLES",
    InfoSupVal: "INSCRIPTIONS : Jean luc Marchesi",
    Mandat: false
  },
  {
    EprvId: 2027109,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-09",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS AMICAL 2027",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027110,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-09",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS SPECIAL JEUNES",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027111,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-09",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS SPECIAL FEMMES OU HOMMES DEGUISES",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027112,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant et confirmé",
    EprvDateDebut: "2027-01-09",
    EprvDateFin: "2027-01-09",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "LOISIRS SALLE 25 M ",
    EprvLieu: "HAUCOURT ST CHARLES 54860",
    InfoSupVal: "en même temps que le x18m",
    Mandat: false
  },
  {
    EprvId: 2027113,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant et confirmé",
    EprvDateDebut: "2027-01-10",
    EprvDateFin: "2027-01-10",
    StructureNom: "HAUCOURT-MOULAINE",
    EprvNom: "LOISIRS 18M AP-MIDI SALLE LEBRUN HAUCOURT MOULAINE",
    EprvLieu: "HAUCOURT  SAINT CHARLES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027114,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-10",
    EprvDateFin: "2027-01-10",
    StructureNom: "VARANGEVILLE",
    EprvNom: "CONCOURS ANNUEL 2027",
    EprvLieu: "VARANGEVILLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027115,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-10",
    EprvDateFin: "2027-01-10",
    StructureNom: "BRUNSTATT",
    EprvNom: "CONCOURS 2 X 18 M",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027116,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-10",
    EprvDateFin: "2027-01-10",
    StructureNom: "BRUNSTATT",
    EprvNom: "FITA SALLE ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027117,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-10",
    EprvDateFin: "2027-01-10",
    StructureNom: "BRUNSTATT",
    EprvNom: "FITA SALLE ",
    EprvLieu: "BRUNSTATT",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027118,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-17",
    StructureNom: "CREUTZWALD",
    EprvNom: "CHAMPIONNAT CD57 JEUNES",
    EprvLieu: "CREUTZWALD",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027119,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-17",
    StructureNom: "VERTUS BLANCS COTEAUX",
    EprvNom: "CONCOURS EN SALLE - VERTUS",
    EprvLieu: "BLANCS  COTEAUX",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027120,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-17",
    StructureNom: "CHARLEVILLE MEZIERES",
    EprvNom: "CHALLENGE DE LA NOUVELLE ANNÉE",
    EprvLieu: "CHARLEVILLE-MÉZIÈRES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027121,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-17",
    StructureNom: "ECLARON",
    EprvNom: "SALLE ECLARON - CD52",
    EprvLieu: "SAINT DIZIER",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027122,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-17",
    StructureNom: "TROYES",
    EprvNom: "CONCOURS SALLE 18M",
    EprvLieu: "TROYES",
    InfoSupVal: "12 cibles",
    Mandat: false
  },
  {
    EprvId: 2027123,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-17",
    StructureNom: "TROYES",
    EprvNom: "CONCOURS SALLE 18M",
    EprvLieu: "TROYES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027124,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-17",
    StructureNom: "EINVILLE",
    EprvNom: "TIR EN SALLE",
    EprvLieu: "EINVILLE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027125,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-16",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "SPÉCIAL JEUNES & DEBUTANTS",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "14 cibles",
    Mandat: false
  },
  {
    EprvId: 2027126,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-01-16",
    EprvDateFin: "2027-01-16",
    StructureNom: "COLMAR",
    EprvNom: "TOURNOI DÉBUTANTS JEUNES ET ADULTES",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027127,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-17",
    EprvDateFin: "2027-01-17",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CONCOURS INDIVIDUEL",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "14 cibles   2 départs",
    Mandat: false
  },
  {
    EprvId: 2027128,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-17",
    EprvDateFin: "2027-01-17",
    StructureNom: "COLMAR",
    EprvNom: "TIR EN SALLE 18M",
    EprvLieu: "COLMAR",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027129,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Confirmé",
    EprvDateDebut: "2027-01-17",
    EprvDateFin: "2027-01-17",
    StructureNom: "TROYES",
    EprvNom: "TROPHEE DES MIXTES",
    EprvLieu: "TROYES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027130,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-17",
    EprvDateFin: "2027-01-17",
    StructureNom: "VAGNEY",
    EprvNom: "TIR EN SALLE DE VAGNEY ",
    EprvLieu: "VAGNEY ",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027131,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-23",
    EprvDateFin: "2027-01-24",
    StructureNom: "MARLY POURNOY",
    EprvNom: "MARLY SALLE",
    EprvLieu: "MARLY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027132,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-23",
    EprvDateFin: "2027-01-24",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES SALLE 2027",
    EprvLieu: "SUIPPES",
    InfoSupVal: "25 cibles",
    Mandat: false
  },
  {
    EprvId: 2027133,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-23",
    EprvDateFin: "2027-01-24",
    StructureNom: "SUIPPES",
    EprvNom: "SUIPPES SALLE 2027",
    EprvLieu: "SUIPPES",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027134,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-23",
    EprvDateFin: "2027-01-24",
    StructureNom: "LUDRES",
    EprvNom: "CHAMPIONAT DEPARTEMENTAL 54 SALLE JEUNES",
    EprvLieu: "LUDRES",
    InfoSupVal: "Réservation Salle faite auprès de la Mairie. Sous réserve de la validation.",
    Mandat: false
  },
  {
    EprvId: 2027135,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-23",
    EprvDateFin: "2027-01-24",
    StructureNom: "ROMILLY SUR SEINE",
    EprvNom: "CHAMPIONNAT AUBE SALLE 2X 18M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "13 cibles",
    Mandat: false
  },
  {
    EprvId: 2027136,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-23",
    EprvDateFin: "2027-01-24",
    StructureNom: "ROMILLY SUR SEINE",
    EprvNom: "CHAMPIONNAT AUBE SALLE 2X 18M",
    EprvLieu: "ROMILLY SUR SEINE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027137,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-01-23",
    EprvDateFin: "2027-01-23",
    StructureNom: "BRUMATH",
    EprvNom: "SPECIAL JEUNES ET ADULTES DEBUTANTS",
    EprvLieu: "67170 BRUMATH",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027138,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-24",
    EprvDateFin: "2027-01-24",
    StructureNom: "MULHOUSE CAB",
    EprvNom: "CHAMPIONNAT DÉPARTEMENTAL 68",
    EprvLieu: "CENTRE SPORTIF RÉGIONAL D'ALSACE - MULHOUSE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027139,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-24",
    EprvDateFin: "2027-01-24",
    StructureNom: "BRUMATH",
    EprvNom: "CONCOURS TIR A 18M - CD 67 JEUNES",
    EprvLieu: "67170 BRUMATH",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027140,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "VOLGELSHEIM",
    EprvNom: "CONCOURS SELECTIF SALLE VOLGELSHEIM ",
    EprvLieu: "VOLGELSHEIM",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027141,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "OBERNAI",
    EprvNom: "OBERNAI - TIR  À 18M - CD 67 ADULTES",
    EprvLieu: "OBERNAI",
    InfoSupVal: "14 cibles",
    Mandat: false
  },
  {
    EprvId: 2027142,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "OBERNAI",
    EprvNom: "OBERNAI - TIR  À 18M - CD 67 ADULTES",
    EprvLieu: "OBERNAI",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027143,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "CD51 SALLE 2027",
    EprvLieu: "AY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027144,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "CD51 SALLE 2027",
    EprvLieu: "AY",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027145,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "VRIGNE AUX BOIS",
    EprvNom: "CONCOURS SALLE CD08",
    EprvLieu: "VRIGNE AUX BOIS",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027146,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "TOUL",
    EprvNom: "CONCOURS SALLE TOUL",
    EprvLieu: "TOUL",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027147,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "TOUL",
    EprvNom: "CONCOURS SALLE TOUL",
    EprvLieu: "TOUL",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027148,
    ChampionnatId: 4,
    ChampionnatLibelle: "Para-tir à l'arc à 18m",
    EprvDateDebut: "2027-01-30",
    EprvDateFin: "2027-01-31",
    StructureNom: "VRIGNE AUX BOIS",
    EprvNom: "CONCOURS SALLE CD08",
    EprvLieu: "VRIGNE AUX BOIS",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027149,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-31",
    EprvDateFin: "2027-01-31",
    StructureNom: "HAGONDANGE",
    EprvNom: "CD57 SALLE ADULTES",
    EprvLieu: "HAGONDANGE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027150,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-01-31",
    EprvDateFin: "2027-01-31",
    StructureNom: "HAGONDANGE",
    EprvNom: "CD57 SALLE ADULTES",
    EprvLieu: "HAGONDANGE",
    InfoSupVal: "25 cibles",
    Mandat: false
  },
  {
    EprvId: 2027152,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-02-13",
    EprvDateFin: "2027-02-14",
    StructureNom: "PONT A MOUSSON",
    EprvNom: "CHAMPIONAT DEPARTEMENTAL SALLE 2027 ADULTES",
    EprvLieu: "PONT-À-MOUSSON",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027153,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-02-13",
    EprvDateFin: "2027-02-13",
    StructureNom: "MAREUIL SUR AY",
    EprvNom: "CONCCOURS  JEUNES",
    EprvLieu: "AY CHAMPAGNE",
    InfoSupVal: "15 CIBLES",
    Mandat: true
  },
  {
    EprvId: 2027154,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-02-14",
    EprvDateFin: "2027-02-14",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CONCOURS INDIVIDUEL FINALES PAR EQUIPES",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "Tir individuel le matin, finales par équipes l'après-midi 14 cibles",
    Mandat: false
  },
  {
    EprvId: 2027155,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-02-14",
    EprvDateFin: "2027-02-14",
    StructureNom: "LINGOLSHEIM",
    EprvNom: "CONCOURS INDIVIDUEL FINALES PAR EQUIPES",
    EprvLieu: "LINGOLSHEIM",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027156,
    ChampionnatId: 7,
    ChampionnatLibelle: "Tir à 18m",
    EprvDateDebut: "2027-02-14",
    EprvDateFin: "2027-02-14",
    StructureNom: "STE CROIX ARC CLUB",
    EprvNom: "2X18M ST VALENTIN",
    EprvLieu: "STE CROIX EN PLAINE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027157,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant et confirmé",
    EprvDateDebut: "2027-03-13",
    EprvDateFin: "2027-03-13",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "CHALLENGE US",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027158,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-03-13",
    EprvDateFin: "2027-03-13",
    StructureNom: "CHALONS EN CHAMPAGNE 1ER",
    EprvNom: "CONCOURS JEUNES",
    EprvLieu: "CHALONS EN CHAMPAGNE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027159,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Confirmé",
    EprvDateDebut: "2027-03-14",
    EprvDateFin: "2027-03-14",
    StructureNom: "MULHOUSE STAM",
    EprvNom: "TROPHÉE DES MIXTES DEPARTEMENTAL",
    EprvLieu: "MULHOUSE",
    InfoSupVal: "",
    Mandat: false
  },
  {
    EprvId: 2027160,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-03-20",
    EprvDateFin: "2027-03-20",
    StructureNom: "OBERNAI",
    EprvNom: "TROPHEE DU PRINTEMPS",
    EprvLieu: "OBERNAI",
    InfoSupVal: "18 cibles - double pas de tir",
    Mandat: false
  },
  {
    EprvId: 2027161,
    ChampionnatId: 3,
    ChampionnatLibelle: "Loisirs Débutant",
    EprvDateDebut: "2027-03-20",
    EprvDateFin: "2027-03-20",
    StructureNom: "RETHEL",
    EprvNom: "CONCOURS JEUNES",
    EprvLieu: "RETHEL",
    InfoSupVal: "",
    Mandat: false
  }
]

export const championnats: Championnat[] = (function initChampionnats(): Championnat[] {
  const result: Championnat[] = []
  const ids: number[] = []

  data.forEach(row => {
    if (ids.includes(row.ChampionnatId)) {
      return
    }

    ids.push(row.ChampionnatId)
    result.push({
      id: row.ChampionnatId,
      name: row.ChampionnatLibelle,
    })
  })

  return result
})()

export default data
